<template>
  <div :class="isModal ? '' : 'container-fluid'">
    <div v-if="!isModal" class="block-header position-sticky">
      <bread-crumb
        :breadCrumbIteams="breadCrumbIteams"
        :showAlert="true"
      ></bread-crumb>
    </div>
    <div class="channel-main">
      <!-- Channel Right Body -->
      <!-- API keys -->
      <div class="channel-right">
        <div class="card">
          <div class="body">
            <div class="row customer-detail">
              <div class="col-12 mb-3 customer-avatar">
                <img
                  :src="require(`@/assets/xs/female-placeholder.webp`)"
                  alt=""
                  class="img-fluid"
                />
              </div>
              <div class="col-xl-4 col-md-6 col-12">
                <ul class="list-unstyled mb-0 striped-list">
                  <li class="p-1">
                    <div class="row">
                      <div class="col-md-5">
                        <strong>Registered Date Time:</strong>
                      </div>
                      <div class="col-md-7">
                        <span>
                          {{
                            basicInfo.registerdate
                              ? basicInfo.registerdate
                              : "--" | changeDateYYYYMMDD
                          }}
                        </span>
                      </div>
                    </div>
                  </li>
                  <li class="p-1">
                    <div class="row">
                      <div class="col-md-5"><strong>Registered IP:</strong></div>
                      <div class="col-md-7">
                        <span>
                          {{
                            basicInfo.registered_ip ? basicInfo.registered_ip : "--"
                          }}
                        </span>
                      </div>
                    </div>
                  </li>
                  <li class="p-1">
                    <div class="row">
                      <div class="col-md-5">
                        <strong>Remitter Id With Remit One:</strong>
                      </div>
                      <div class="col-md-7">
                        <span>
                          {{
                            basicInfo.remitterid ? basicInfo.remitterid : "--"
                          }}
                        </span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="col-xl-4 col-md-6 col-12">
                <ul class="list-unstyled mb-0 striped-list">
                  <li class="p-1">
                    <div class="row">
                      <div class="col-md-5">
                        <strong>Payangel ID:</strong>
                      </div>
                      <div class="col-md-7 d-flex">
                        <span>
                          {{
                            basicInfo.payangelid ? basicInfo.payangelid : "--"
                          }}
                        </span>
                        <router-link
                          class="text-bold text-danger pull-right pl-3"
                          :to="{
                            name: 'beneficiary-all',
                            query: { customer_id: this.$CryptoJS.AES.encrypt(decryptedCustomerId, 'customer_id').toString() },
                          }"
                          target="_blank"
                        >
                          See Receivers
                        </router-link>
                      </div>
                    </div>
                  </li>
                  <li class="p-1">
                    <div class="row">
                      <div class="col-md-5">
                        <strong>ID3 Authentication ID(Registered):</strong>
                      </div>
                      <div class="col-md-7">
                        <span>
                          {{
                            basicInfo.authenticationRegistered
                              ? basicInfo.authenticationRegistered
                              : "--"
                          }}
                        </span>
                      </div>
                    </div>
                  </li>
                  <li class="p-1">
                    <div class="row">
                      <div class="col-md-5">
                        <strong>ID3 Authentication ID(Upgraded):</strong>
                      </div>
                      <div class="col-md-7">
                        <span>
                          {{
                            basicInfo.authenticationUpgraded
                              ? basicInfo.authenticationUpgraded
                              : "--"
                          }}
                        </span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="col-xl-4 col-md-6 col-12">
                <ul class="list-unstyled mb-0 striped-list">
                  <li class="p-1">
                    <div class="row">
                      <div class="col-md-5">
                        <strong>ID3 BandText1:</strong>
                      </div>
                      <div class="col-md-7">
                        <span>
                          {{ basicInfo.bandText1 ? basicInfo.bandText1 : "--" }}
                        </span>
                      </div>
                    </div>
                  </li>
                  <li class="p-1">
                    <div class="row">
                      <div class="col-md-5">
                        <strong>ID3 BandText2:</strong>
                      </div>
                      <div class="col-md-7">
                        <span>
                          {{ basicInfo.bandText2 ? basicInfo.bandText2 : "--" }}
                        </span>
                      </div>
                    </div>
                  </li>
                  <li class="p-1">
                    <div class="row">
                      <div class="col-md-5">
                        <strong>ID3 Score(Registered):</strong>
                      </div>
                      <div class="col-md-7">
                        <span>
                          {{
                            basicInfo.scoreRegistered
                              ? basicInfo.scoreRegistered
                              : "--"
                          }}
                        </span>
                      </div>
                    </div>
                  </li>
                  <li class="p-1">
                    <div class="row">
                      <div class="col-md-5">
                        <strong>ID3 Score(Upgraded):</strong>
                      </div>
                      <div class="col-md-7">
                        <span>
                          {{
                            basicInfo.scoreUpgraded
                              ? basicInfo.scoreUpgraded
                              : "--"
                          }}
                        </span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- PayAngel Wallet Card -->
        <div
          class="card mt-3"
          v-if="basicInfo.wallets && basicInfo.wallets.length > 0"
        >
          <div class="header border-bottom">
            <h5 class="text-primary font-weight-normal mb-0">
              PayAngel Wallet
            </h5>
          </div>
          <div class="body">
            <div
              class="row"
              v-for="(wallet, index) in basicInfo.wallets"
              :key="index"
            >
              <div class="col-12 mb-3" v-if="index > 0">
                <hr />
              </div>
              <div class="col-md-6 col-12 mb-3">
                <div
                  class="d-flex justify-content-between align-items-center p-2 border rounded"
                >
                  <div>
                    <strong>Available Balance:</strong>
                  </div>
                  <div class="text-right">
                    <span class="font-weight-bold text-success">
                      {{
                        wallet.availablebalance
                          | amountFormat(wallet.currencycode)
                      }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-12 mb-3">
                <div
                  class="d-flex justify-content-between align-items-center p-2 border rounded"
                >
                  <div>
                    <strong>Actual Balance:</strong>
                  </div>
                  <div class="text-right">
                    <span class="font-weight-bold text-primary">
                      {{
                        wallet.actualbalance | amountFormat(wallet.currencycode)
                      }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-12" v-if="wallet.name || wallet.walletnumber">
                <div class="row">
                  <div class="col-md-6" v-if="wallet.name">
                    <small class="text-muted">
                      <strong>Wallet Name:</strong>
                      {{ wallet.name }}
                    </small>
                  </div>
                  <div class="col-md-6" v-if="wallet.walletnumber">
                    <small class="text-muted">
                      <strong>Wallet Number:</strong>
                      {{ wallet.walletnumber }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-md-flex">
          <div class="card mr-2">
            <div class="header border-bottom">
              <h5 class="text-primary font-weight-normal mb-0">
                ID Documents Uploaded in IDScan
              </h5>
            </div>
            <div class="body">
              <div class="id-img">
                <b-carousel controls indicators :interval="0">
                  <b-carousel-slide v-for="(image, i) in IDimages" :key="i">
                    <template #img>
                      <zoom-on-hover
                        :img-normal="image"
                        :img-zoom="image"
                        :scale="2"
                      ></zoom-on-hover>
                    </template>
                  </b-carousel-slide>
                </b-carousel>
              </div>
              <div class="id-info">
                <ul class="list-unstyled">
                  <li class="mb-2">
                    <strong>ID Scan Results:</strong>
                    <div
                      class="d-block m-1 ml-3"
                      v-for="(item, index) in idScanDetails"
                      :key="index"
                    >
                      <div
                        class="border bg-dark-50 p-2 accordian-toggle"
                        v-b-toggle="'result-' + index"
                      >
                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <div>
                            <span class="font-weight-bold mr-2">
                              Attempt-{{ index + 1 }}
                            </span>
                            {{ item.journeyId }}
                          </div>
                          <span
                            class="font-weight-bold mr-5"
                            v-bind:class="{
                              'text-success': item.scanStatus == 'Passed',
                              'text-danger': item.scanStatus != 'Passed',
                            }"
                          >
                            {{ item.scanStatus }}
                          </span>
                        </div>
                      </div>
                      <b-collapse
                        :id="'result-' + index"
                        class="border border-top-0"
                      >
                        <div class="d-flex p-2">
                          <img
                            v-if="item.selfieVerificationURL"
                            :src="item.selfieVerificationURL"
                            alt="id image"
                            class="img-fluid w-25 mr-2"
                          />
                          <p>{{ item.scanResponse }}</p>
                        </div>
                      </b-collapse>
                    </div>
                  </li>
                  <li class="mb-2">
                    <strong>Documents:</strong>
                    <div class="row">
                      <!-- Selfie Column -->
                      <div class="col-6">
                        <h6>Selfie Images</h6>
                        <div
                          class="mb-2 row ml-2"
                          v-for="(doc, index) in selfieDocuments"
                          :key="'selfie-' + index"
                        >
                          <span class="col-12">
                            <i class="fa fa-file"></i>
                            <a :href="doc.url" download>
                              {{ doc.name }}
                            </a>
                          </span>
                        </div>
                        <div
                          class="mb-2 row ml-2"
                          v-if="selfieDocuments.length === 0"
                        >
                          <span class="col-12">No selfie images available</span>
                        </div>
                      </div>

                      <!-- ID Documents Column -->
                      <div class="col-6">
                        <h6>ID Documents</h6>
                        <div
                          class="mb-2 row ml-2"
                          v-for="(doc, index) in idDocuments"
                          :key="'id-' + index"
                        >
                          <span class="col-12">
                            <i class="fa fa-file"></i>
                            <a :href="doc.url" download>
                              {{ doc.name }}
                            </a>
                          </span>
                        </div>
                        <div
                          class="mb-2 row ml-2"
                          v-if="idDocuments.length === 0"
                        >
                          <span class="col-12">No ID documents available</span>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <a href="#document_notification_logs">
                View Upload Document Notification Logs
              </a>
              <div class="d-flex justify-content-center">
                <!-- <b-button class="btn-lg btn-mw mt-3" variant='primary' v-b-modal.generateDocumentUpload>Upload Document Link</b-button> -->
                <b-button
                  class="btn-lg btn-mw mt-3"
                  variant="primary"
                  v-b-modal.sendDocumentNotification
                >
                  Request Document / link
                  <i
                    class="icon-question"
                    v-b-tooltip.hover
                    title="Lorem Ipsum is simply dummy text of the printing and typesetting industry"
                  ></i>
                </b-button>
              </div>
            </div>
            <b-modal
              id="sendDocumentNotification"
              size="lg"
              no-stacking
              no-close-on-backdrop
              hide-footer
              hide-header-close
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  Are you sure you want to send the notification to customer?
                </h5>
              </template>
              <div class="modal-area">
                <ValidationObserver v-slot="{ passes }">
                  <form @submit.prevent="passes(sendDocumentemailSubmit)">
                    <ValidationProvider
                      name="documentEmailType"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group form-select single-multiselect select-option-custom"
                        :class="{
                          errors: errors[0],
                          success: documentEmail.documenttype && !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <label for="documentEmailType">
                            Select Document Type*
                          </label>
                          <multiselect
                            placeholder=""
                            v-model="documentEmail.documenttype"
                            :show-labels="false"
                            :options="documentType_options"
                            @select="changeEmailSubject()"
                          ></multiselect>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && errors[0]"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="documentEmail.documenttype && !errors[0]"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <ul class="d-flex social-mail list-unstyled mb-4">
                      <li>
                        <label class="fancy-radio">
                          <input
                            type="radio"
                            name="notificationtype"
                            value="Email"
                            v-model="documentEmail.type"
                          />
                          <span v-b-tooltip.hover title="Email">
                            <i class="icon-envelope"></i>
                          </span>
                        </label>
                      </li>
                      <li>
                        <label class="fancy-radio">
                          <input
                            type="radio"
                            name="notificationtype"
                            value="Whatsapp"
                            v-model="documentEmail.type"
                          />
                          <span v-b-tooltip.hover title="Whatsapp">
                            <i class="fa fa-whatsapp"></i>
                          </span>
                        </label>
                      </li>
                      <li>
                        <label class="fancy-radio">
                          <input
                            type="radio"
                            name="notificationtype"
                            value="SMS"
                            v-model="documentEmail.type"
                          />
                          <span v-b-tooltip.hover title="SMS">
                            <i class="fa fa-inbox"></i>
                          </span>
                        </label>
                      </li>
                      <li>
                        <label class="fancy-radio">
                          <input
                            type="radio"
                            name="notificationtype"
                            value="Push"
                            v-model="documentEmail.type"
                          />
                          <span v-b-tooltip.hover title="Push Notification">
                            <i class="fa fa-bell"></i>
                          </span>
                        </label>
                      </li>
                    </ul>
                    <ValidationProvider
                      name="documentEmail_other"
                      rules="required"
                      v-slot="{ errors }"
                      v-if="documentEmail.documenttype == 'Other'"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !documentEmail.other,
                          success: documentEmail.other,
                        }"
                      >
                        <span class="float-label">
                          <input
                            type="text"
                            v-model="documentEmail.other"
                            class="form-control"
                            id="documentEmail_other"
                            placeholder="documentEmail_other*"
                          />
                          <label
                            for="documentEmail_other"
                            class="control-label"
                          >
                            Document Name*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !documentEmail.other"
                          ></i>
                          <i class="fa fa-check" v-if="documentEmail.other"></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <template v-if="documentEmail.type == 'Email'">
                      <ValidationProvider
                        name="email_notification_subject"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <div
                          class="form-group"
                          :class="{
                            errors:
                              errors.length &&
                              !documentEmail.email_notification_subject,
                            success: documentEmail.email_notification_subject,
                          }"
                        >
                          <span class="float-label">
                            <input
                              type="text"
                              v-model="documentEmail.email_notification_subject"
                              class="form-control"
                              id="email_notification"
                              placeholder="Company Name*"
                            />
                            <label
                              for="email_notification"
                              class="control-label"
                            >
                              Email subject*
                            </label>
                            <div class="line"></div>
                            <i
                              class="fa fa-times"
                              v-if="
                                errors.length &&
                                !documentEmail.email_notification_subject
                              "
                            ></i>
                            <i
                              class="fa fa-check"
                              v-if="documentEmail.email_notification_subject"
                            ></i>
                          </span>
                        </div>
                      </ValidationProvider>
                      <ValidationProvider
                        name="documentEmailContent"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <div
                          class="form-group"
                          :class="{
                            errors:
                              errors.length &&
                              !documentEmail.email_notification_content,
                            success: documentEmail.email_notification_content,
                          }"
                        >
                          <label
                            for="documentEmailContent"
                            class="control-label"
                          >
                            Email Body*
                          </label>
                          <span class="float-label">
                            <vue-editor
                              v-model="documentEmail.email_notification_content"
                            ></vue-editor>
                            <div class="line"></div>
                            <i
                              class="fa fa-times"
                              v-if="
                                errors.length &&
                                !documentEmail.email_notification_content
                              "
                            ></i>
                            <i
                              class="fa fa-check"
                              v-if="documentEmail.email_notification_content"
                            ></i>
                          </span>
                        </div>
                      </ValidationProvider>
                    </template>
                    <template v-if="documentEmail.type == 'Push'">
                      <ValidationProvider
                        name="push_notification_title"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <div
                          class="form-group"
                          :class="{
                            errors:
                              errors.length &&
                              !documentEmail.push_notification.title,
                            success: documentEmail.push_notification.title,
                          }"
                        >
                          <span class="float-label">
                            <input
                              type="text"
                              v-model="documentEmail.push_notification.title"
                              class="form-control"
                              id="push_notification"
                              placeholder="Company Name*"
                            />
                            <label
                              for="push_notification"
                              class="control-label"
                            >
                              Push Notification Title*
                            </label>
                            <div class="line"></div>
                            <i
                              class="fa fa-times"
                              v-if="
                                errors.length &&
                                !documentEmail.push_notification.title
                              "
                            ></i>
                            <i
                              class="fa fa-check"
                              v-if="documentEmail.push_notification.title"
                            ></i>
                          </span>
                        </div>
                      </ValidationProvider>
                      <ValidationProvider
                        name="push_notification_content"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <div
                          class="form-group"
                          :class="{
                            errors:
                              errors.length &&
                              !documentEmail.push_notification.content,
                            success: documentEmail.push_notification.content,
                          }"
                        >
                          <span class="float-label">
                            <textarea
                              type="text"
                              rows="3"
                              v-model="documentEmail.push_notification.content"
                              class="form-control"
                              id="push_notification_content"
                              placeholder="Company Name*"
                            ></textarea>
                            <label
                              for="push_notification_content"
                              class="control-label"
                            >
                              Push Notification Content*
                            </label>
                            <div class="line"></div>
                            <i
                              class="fa fa-times"
                              v-if="
                                errors.length &&
                                !documentEmail.push_notification.content
                              "
                            ></i>
                            <i
                              class="fa fa-check"
                              v-if="documentEmail.push_notification.content"
                            ></i>
                          </span>
                        </div>
                      </ValidationProvider>
                    </template>
                    <!-- SMS -->
                    <template v-if="documentEmail.type == 'SMS'">
                      <ValidationProvider
                        name="sms_notification_content"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <div
                          class="form-group"
                          :class="{
                            errors:
                              errors.length &&
                              !documentEmail.sms_notification_content,
                            success: documentEmail.sms_notification_content,
                          }"
                        >
                          <span class="float-label">
                            <textarea
                              type="text"
                              rows="3"
                              v-model="documentEmail.sms_notification_content"
                              class="form-control"
                              @input="handleEditorInput"
                              @keydown="handleKeyDown"
                              id="sms_notification_content"
                              placeholder="Company Name*"
                            ></textarea>
                            <label
                              for="sms_notification_content"
                              class="control-label"
                            >
                              SMS Content*
                            </label>
                            <div class="line"></div>
                            <i
                              class="fa fa-times"
                              v-if="
                                errors.length &&
                                !documentEmail.sms_notification_content
                              "
                            ></i>
                            <i
                              class="fa fa-check"
                              v-if="documentEmail.sms_notification_content"
                            ></i>
                          </span>
                          <p class="text-right">
                            {{
                              documentEmail.sms_notification_content.length
                            }}/320
                          </p>
                        </div>
                      </ValidationProvider>
                    </template>
                    <!-- SMS -->

                    <!-- Whatsapp -->
                    <template v-if="documentEmail.type == 'Whatsapp'">
                      <ValidationProvider
                        name="whatsapp_notification_content"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <div
                          class="form-group"
                          :class="{
                            errors:
                              errors.length &&
                              !documentEmail.whatsapp_notification_content,
                            success:
                              documentEmail.whatsapp_notification_content,
                          }"
                        >
                          <span class="float-label">
                            <textarea
                              type="text"
                              rows="5"
                              v-model="
                                documentEmail.whatsapp_notification_content
                              "
                              class="form-control"
                              id="whatsapp_notification_content"
                              placeholder="Company Name*"
                            ></textarea>
                            <label
                              for="whatsapp_notification_content"
                              class="control-label"
                            >
                              Whatsapp Content*
                            </label>
                            <div class="line"></div>
                            <i
                              class="fa fa-times"
                              v-if="
                                errors.length &&
                                !documentEmail.whatsapp_notification_content
                              "
                            ></i>
                            <i
                              class="fa fa-check"
                              v-if="documentEmail.whatsapp_notification_content"
                            ></i>
                          </span>
                        </div>
                      </ValidationProvider>
                    </template>
                    <!-- Whatsapp -->
                    <div
                      class="d-flex flex-column flex-md-row justify-content-center mt-2"
                    >
                      <b-button
                        variant="secondary btn-mw"
                        size="lg"
                        @click="$bvModal.hide('sendDocumentNotification')"
                      >
                        Cancel
                      </b-button>
                      <b-button
                        type="submit"
                        variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                        size="lg"
                      >
                        Confirm and Send
                      </b-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </b-modal>
            <b-modal
              id="generateDocumentUpload"
              size="md"
              no-stacking
              no-close-on-backdrop
              hide-footer
              hide-header-close
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  Generate Upload Document Link
                </h5>
              </template>
              <div class="modal-area">
                <ValidationObserver v-slot="{ passes }">
                  <form
                    @submit.prevent="passes(generateUploadLink)"
                    id="basic-form"
                  >
                    <ValidationProvider
                      name="documentType"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group form-select single-multiselect select-option-custom"
                        :class="{
                          errors: errors[0],
                          success: document.type && !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <label for="documentType">
                            Select Document Type*
                          </label>
                          <multiselect
                            placeholder=""
                            v-model="document.type"
                            :show-labels="false"
                            :options="documentType_options"
                          ></multiselect>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && errors[0]"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="document.type && !errors[0]"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="document_other"
                      rules="required"
                      v-slot="{ errors }"
                      v-if="document.type == 'Other'"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !document.other,
                          success: document.other,
                        }"
                      >
                        <span class="float-label">
                          <input
                            type="text"
                            v-model="document.other"
                            class="form-control"
                            id="document_other"
                            placeholder="document_other*"
                          />
                          <label for="document_other" class="control-label">
                            Other Document*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !document.other"
                          ></i>
                          <i class="fa fa-check" v-if="document.other"></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <div
                      class="form-group datepicker"
                      v-if="document.generatedlink"
                    >
                      <label for="generatedlink" class="control-label pr-2">
                        Generated Link:
                      </label>
                      <span class="float-label">
                        <b-input-group>
                          <input
                            type="text"
                            class="form-control"
                            id="generatedlink"
                            v-model="document.generatedlink"
                            readonly
                          />
                          <div class="input-group-append">
                            <span class="input-group-text" @click="copyLink">
                              <i class="fa fa-copy"></i>
                            </span>
                          </div>
                        </b-input-group>
                      </span>
                    </div>
                    <div
                      class="d-flex flex-column flex-md-row justify-content-center"
                    >
                      <b-button
                        variant="secondary btn-mw"
                        size="lg"
                        @click="cancelmodel"
                      >
                        Cancel
                      </b-button>
                      <b-button
                        type="submit"
                        variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                        size="lg"
                      >
                        Submit
                      </b-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </b-modal>
          </div>
          <div class="ml-2 w-100">
            <PersonalInfo
              :key="decryptedCustomerId"
              :customerId="decryptedCustomerId"
              :accountStatuses="accountStatuses"
              :customerDetails="basicInfo"
            />
            <div class="card customer-notification">
              <div class="header border-bottom">
                <h5 class="text-primary font-weight-normal mb-0">
                  Remitter Notification
                </h5>
              </div>
              <div class="body">
                <ValidationObserver v-slot="{ passes }">
                  <form @submit.prevent="passes(userSubmitData)">
                    <ValidationProvider
                      name="notification_type"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group form-select multiselect-grp"
                        :class="{
                          errors: errors[0],
                          success:
                            notification.type &&
                            notification.type.length != 0 &&
                            !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <label for="notification_type">
                            Notification Type*
                          </label>
                          <multiselect
                            placeholder=""
                            v-model="notification.type"
                            :show-labels="false"
                            :options="notificationTypeOptions"
                          ></multiselect>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && errors[0]"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="
                              notification.type &&
                              notification.type.length != 0 &&
                              !errors[0]
                            "
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="notification_action"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group form-select multiselect-grp"
                        :class="{
                          errors: errors[0],
                          success:
                            notification.action &&
                            notification.action.length != 0 &&
                            !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <label for="notification_action">
                            Notification Action*
                          </label>
                          <multiselect
                            placeholder=""
                            v-model="notification.action"
                            :show-labels="false"
                            :options="notificationActionOptions"
                          ></multiselect>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && errors[0]"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="
                              notification.action &&
                              notification.action.length != 0 &&
                              !errors[0]
                            "
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="notification_custom"
                      rules="required"
                      v-slot="{ errors }"
                      v-if="notification.action == 'Other'"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors:
                            (errors.length && !notification.custom) ||
                            errors[0],
                          success: notification.custom && !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <textarea
                            class="form-control"
                            id="notification_custom"
                            v-model="notification.custom"
                            placeholder=" "
                          ></textarea>
                          <label
                            for="notification_custom"
                            class="control-label"
                          >
                            Custom Notification Text*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="
                              (errors.length && !notification.custom) ||
                              errors[0]
                            "
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="notification.custom && !errors[0]"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <div class="text-right mb-1">
                      <a href="#remitter_notification_logs">
                        View Remitter Notification Logs
                      </a>
                    </div>
                    <div
                      class="d-flex flex-column flex-md-row justify-content-center"
                    >
                      <b-button
                        variant="secondary btn-mw"
                        size="lg"
                        @click="cancel()"
                      >
                        Cancel
                      </b-button>
                      <b-button
                        type="submit"
                        variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                        size="lg"
                        @click="isDisplayPhoneError = true"
                      >
                        Submit
                      </b-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>

        <div class="d-md-flex align-items-start">
          <Address :customerId="decryptedCustomerId" />
          <IdAndAccount
            :customerId="decryptedCustomerId"
            :countryOfResidenceId="basicInfo?.countryofResidence"
            :accountStatuses="accountStatuses"
          />
        </div>
        <div class="d-md-flex align-items-start">
          <Risk :customerId="decryptedCustomerId" />
          <div class="card ml-2">
            <div
              class="header border-bottom accordian-toggle"
              v-b-toggle.cardlist
              @click="getcustomerCards"
            >
              <h5 class="text-primary font-weight-normal mb-0">Card List</h5>
            </div>
            <b-collapse id="cardlist">
              <div class="body">
                <b-table
                  responsive
                  outlined
                  table-class="mb-0 table-custom"
                  head-variant="light"
                  :items="cardList"
                  :fields="cardListfields"
                  :emptyText="'No Cards found.'"
                  show-empty
                  striped
                >
                  <template #cell(type)="data">
                    {{ data.item.name }} ({{ data.item.type }})
                  </template>
                  <template #cell(block_status)="data">
                    <select
                      class="btn btn-filter badge badge-primary btn-sm"
                      v-model="data.value"
                    >
                      <option value="">Select Option</option>
                      <option
                        v-for="(option, index) in blockStatuses"
                        :key="index"
                        :value="option"
                      >
                        {{ option.value }}
                      </option>
                    </select>
                  </template>
                </b-table>
              </div>
            </b-collapse>
          </div>
        </div>
        <div class="d-md-flex align-items-start">
          <div class="card mr-2">
            <div
              class="header border-bottom accordian-toggle"
              v-b-toggle.bankAccounts
              @click="getBankAccounts"
            >
              <h5 class="text-primary font-weight-normal mb-0">
                Bank Accounts
              </h5>
            </div>
            <b-collapse id="bankAccounts">
              <div class="body">
                <b-table
                  responsive
                  outlined
                  table-class="mb-0 table-custom"
                  head-variant="light"
                  :items="banksaccounts"
                  :fields="bankfields"
                  :emptyText="'No data found.'"
                  show-empty
                  striped
                >
                  <template #cell(account_number)="data">
                    <a
                      href="javascript:void(0);"
                      @click="viewAccounts(data.item)"
                    >
                      {{ data.value }}
                    </a>
                  </template>
                  <template #cell(block_status)="data">
                    <select
                      class="btn btn-filter badge badge-primary btn-sm"
                      v-model="data.value"
                    >
                      <option value="">Select Option</option>
                      <option
                        v-for="(option, index) in blockStatuses"
                        :key="index"
                        :value="option"
                      >
                        {{ option.value }}
                      </option>
                    </select>
                  </template>
                </b-table>
              </div>
            </b-collapse>
          </div>
          <div class="card ml-2">
            <div
              class="header border-bottom accordian-toggle"
              v-b-toggle.momoAccounts
              @click="getmomoAccounts"
            >
              <h5 class="text-primary font-weight-normal mb-0">
                MOMO Accounts
              </h5>
            </div>
            <b-collapse id="momoAccounts">
              <div class="body">
                <b-table
                  responsive
                  outlined
                  table-class="mb-0 table-custom"
                  head-variant="light"
                  :items="momoaccounts"
                  :fields="momoaccountfields"
                  :emptyText="'No data found.'"
                  show-empty
                  striped
                >
                  <template #cell(momo_number)="data">
                    <a
                      href="javascript:void(0);"
                      @click="viewAccounts(data.item)"
                    >
                      {{ data.value }}
                    </a>
                  </template>
                  <template #cell(block_status)="data">
                    {{ data.value }}
                    <select
                      class="btn btn-filter badge badge-primary btn-sm"
                      v-model="data.value"
                    >
                      <option value="">Select Option</option>
                      <option
                        v-for="(option, index) in blockStatuses"
                        :key="index"
                        :value="option"
                      >
                        {{ option.value }}
                      </option>
                    </select>
                  </template>
                </b-table>
              </div>
            </b-collapse>
          </div>
        </div>
        <div class="d-md-flex align-items-start">
          <IdReverification :customerId="decryptedCustomerId" style="flex: 0 0 50%; max-width: 50%;" />
        </div>
        <div class="card comment-box">
          <div
            class="header border-bottom accordian-toggle"
            v-b-toggle.comments
          >
            <h5 class="text-primary font-weight-normal mb-0">Comments</h5>
          </div>
          <b-collapse id="comments">
            <div class="body" ref="comments">
              <div
                class="d-block"
                v-for="(item, index) in usercomments"
                :key="index"
              >
                <span class="font-weight-bold font-14 mr-2">
                  {{ item.name }}
                </span>
                <span class="font-12">{{ item.date }}</span>
                <div class="card p-3">
                  <p>{{ item.comment }}</p>
                  <div class="d-block ml-4" v-if="item.edited">
                    Edited By
                    <span class="font-weight-bold font-14 mr-2">
                      {{ item.editedby }}
                    </span>
                    <span class="font-12">{{ item.editOn }}</span>
                    <!-- <div class="card p-3">
                      <p class="mb-0">{{ item.editMsg }}</p>
                    </div> -->
                  </div>
                  <i
                    class="fa fa-edit text-right"
                    @click="editComment(item)"
                  ></i>
                </div>
              </div>
            </div>
            <div class="footer m-0 w-100 p-2">
              <div class="d-flex justify-content-between">
                <input
                  type="text"
                  class="form-control mr-2"
                  id=""
                  v-model="addComment"
                />
                <button class="btn btn-primary" @click="createComment">
                  Add Comment
                </button>
              </div>
            </div>
            <b-modal id="editComment" title="Edit Comment" @ok="updateComment">
              <div class="form-group">
                <span class="float-label">
                  <input
                    class="form-control"
                    id="comment"
                    v-model="editComentMsg"
                    placeholder="Address Line 2"
                  />
                  <label for="comment" class="control-label">
                    Edit Comment
                  </label>
                  <div class="line"></div>
                </span>
              </div>
            </b-modal>
          </b-collapse>
        </div>
        <div class="card">
          <div
            class="header border-bottom accordian-toggle"
            v-b-toggle.editLogs
          >
            <h5 class="text-primary font-weight-normal mb-0">
              Admin Activity Logs
            </h5>
          </div>
          <b-collapse id="editLogs" @show="getActivityLogs">
            <div class="body">
              <div v-if="activityLogsLoading" class="text-center p-4">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <p class="mt-2 text-muted">Loading activity logs...</p>
              </div>
              <div
                v-else-if="activityLogs.length === 0"
                class="text-center text-muted p-3"
              >
                No activity logs available
              </div>
              <div
                v-else
                class="d-block accordion mb-1"
                v-for="(log, index) in activityLogs"
                :key="index"
              >
                <div class="border bg-dark-50 p-2">
                  <div class="row">
                    <div class="col-12 col-md-3 mb-2 mb-md-0">
                      <span class="font-weight-bold">
                        {{
                          log.user && log.user.username
                            ? log.user.username
                            : "System"
                        }}
                      </span>
                    </div>
                    <div class="col-12 col-md-6 mb-2 mb-md-0">
                      <span>{{ log.timestamp | changeDateYYYYMMDD }}</span>
                    </div>
                    <div
                      class="col-12 col-md-3 d-flex align-items-center justify-content-md-end"
                    >
                      <span
                        class="font-weight-bold mr-2"
                        :class="
                          log.outcome === 'success'
                            ? 'text-success'
                            : 'text-danger'
                        "
                      >
                        {{ log.outcome ? log.outcome.toUpperCase() : "N/A" }}
                      </span>
                      <span></span>
                    </div>
                  </div>
                </div>
                <div class="border border-top-0 p-2">
                  <div class="row">
                    <!-- Action Column -->
                    <div class="col-12 col-md-3 mb-2 mb-md-0">
                      <div class="border bg-light p-2 rounded">
                        <div
                          class="d-flex align-items-center justify-content-between mb-1"
                        >
                          <strong>Action</strong>
                          <button
                            class="btn btn-sm btn-link p-0"
                            @click="
                              $set(log, 'actionExpanded', !log.actionExpanded)
                            "
                          >
                            <i
                              :class="
                                log.actionExpanded
                                  ? 'fa fa-chevron-up'
                                  : 'fa fa-chevron-down'
                              "
                            ></i>
                          </button>
                        </div>
                        <div v-if="log.actionExpanded">
                          <div class="small">
                            <strong>{{ getActionText(log.method) }}</strong>
                            <div class="mt-1 text-muted">
                              Section:
                              {{
                                log.request && log.request.url
                                  ? log.request.url
                                  : "N/A"
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Request Sent Column -->
                    <div class="col-12 col-md-3 mb-2 mb-md-0">
                      <div class="border bg-light p-2 rounded">
                        <div
                          class="d-flex align-items-center justify-content-between mb-1"
                        >
                          <strong>Request Sent</strong>
                          <button
                            class="btn btn-sm btn-link p-0"
                            @click="
                              $set(log, 'requestExpanded', !log.requestExpanded)
                            "
                          >
                            <i
                              :class="
                                log.requestExpanded
                                  ? 'fa fa-chevron-up'
                                  : 'fa fa-chevron-down'
                              "
                            ></i>
                          </button>
                        </div>
                        <div
                          v-if="
                            log.requestExpanded &&
                            log.request &&
                            log.request.body
                          "
                        >
                          <pre
                            class="bg-white p-2 rounded small mb-0"
                            style="max-height: 300px; overflow-y: auto"
                            >{{
                              JSON.stringify(log.request.body, null, 2)
                            }}</pre
                          >
                        </div>
                      </div>
                    </div>

                    <!-- Response Column -->
                    <div class="col-12 col-md-3 mb-2 mb-md-0">
                      <div class="border bg-light p-2 rounded">
                        <div
                          class="d-flex align-items-center justify-content-between mb-1"
                        >
                          <strong>Response</strong>
                          <button
                            class="btn btn-sm btn-link p-0"
                            @click="
                              $set(
                                log,
                                'responseExpanded',
                                !log.responseExpanded,
                              )
                            "
                          >
                            <i
                              :class="
                                log.responseExpanded
                                  ? 'fa fa-chevron-up'
                                  : 'fa fa-chevron-down'
                              "
                            ></i>
                          </button>
                        </div>
                        <div
                          v-if="
                            log.responseExpanded &&
                            log.response &&
                            log.response.body
                          "
                        >
                          <pre
                            class="bg-white p-2 rounded small mb-0"
                            style="max-height: 300px; overflow-y: auto"
                            >{{
                              JSON.stringify(log.response.body, null, 2)
                            }}</pre
                          >
                        </div>
                      </div>
                    </div>

                    <!-- Device Info Column -->
                    <div class="col-12 col-md-3 mb-2 mb-md-0">
                      <div class="border bg-light p-2 rounded">
                        <div
                          class="d-flex align-items-center justify-content-between mb-1"
                        >
                          <strong>Device Info</strong>
                          <button
                            class="btn btn-sm btn-link p-0"
                            @click="
                              $set(
                                log,
                                'deviceInfoExpanded',
                                !log.deviceInfoExpanded,
                              )
                            "
                          >
                            <i
                              :class="
                                log.deviceInfoExpanded
                                  ? 'fa fa-chevron-up'
                                  : 'fa fa-chevron-down'
                              "
                            ></i>
                          </button>
                        </div>
                        <div v-if="log.deviceInfoExpanded && log.device">
                          <pre
                            class="bg-white p-2 rounded small mb-0"
                            style="max-height: 300px; overflow-y: auto"
                            >{{ JSON.stringify(log.device, null, 2) }}</pre
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-collapse>
        </div>
        <div class="card" id="document_notification_logs">
          <div
            class="header border-bottom accordian-toggle"
            v-b-toggle.documentNotificationLogs
          >
            <h5 class="text-primary font-weight-normal mb-0">
              Upload Document Notification Log
            </h5>
          </div>
          <b-collapse id="documentNotificationLogs">
            <div class="body">
              <div class="d-block accordion mb-1">
                <div class="border bg-dark-50 p-2" v-b-toggle.log-1>
                  <div class="row">
                    <div class="col-3 d-flex align-items-center">
                      <i
                        class="icon-envelope lh-base"
                        v-b-tooltip.hover
                        title="Email"
                      ></i>
                      <span class="font-weight-bold font-14 ml-2">
                        Mark Richards
                      </span>
                    </div>
                    <div class="col-6 d-flex">
                      <strong class="mr-2">Email Subject:</strong>
                      <span>Request for Passport</span>
                    </div>
                    <div
                      class="col-3 d-flex align-items-center justify-content-end"
                    >
                      <span class="font-12 mr-2">2022-08-19 06:37:47</span>
                      <i class="fa fa-chevron-up open"></i>
                      <i class="fa fa-chevron-down closed"></i>
                    </div>
                  </div>
                </div>
                <b-collapse id="log-1" class="p-2 border border-top-0">
                  <strong>Message:</strong>
                  <span class="ml-3">
                    <p>Hello mark,</p>
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer took a galley of type and scrambled it to make a
                      type specimen book. It has survived not only five
                      centuries, but also the leap into electronic typesetting,
                      remaining essentially unchanged.
                    </p>
                    <p>
                      Here is the link to upload your documents:
                      <a
                        class="text-bold"
                        :href="document.generatedlink"
                        target="_blank"
                      >
                        {{ document.generatedlink }}
                      </a>
                    </p>
                  </span>
                </b-collapse>
              </div>
              <div class="d-block accordion mb-1">
                <div class="border bg-dark-50 p-2" v-b-toggle.log-2>
                  <div class="row">
                    <div class="col-3 d-flex align-items-center">
                      <i
                        class="fa fa-bell"
                        v-b-tooltip.hover
                        title="Push Notification"
                      ></i>
                      <span class="font-weight-bold font-14 ml-2">
                        Selena Parker
                      </span>
                    </div>
                    <div class="col-6 d-flex">
                      <strong class="mr-2">Push Notification Title:</strong>
                      <span>Request for Passport</span>
                    </div>
                    <div
                      class="col-3 d-flex align-items-center justify-content-end"
                    >
                      <span class="font-12 mr-2">2022-08-19 06:37:47</span>
                      <i class="fa fa-chevron-up open"></i>
                      <i class="fa fa-chevron-down closed"></i>
                    </div>
                  </div>
                </div>
                <b-collapse id="log-2" class="p-2 border border-top-0">
                  <strong>Message:</strong>
                  <span class="ml-3">
                    <p>Hello mark,</p>
                    <p>
                      Here is the link to upload your documents:
                      <a
                        class="text-bold"
                        :href="document.generatedlink"
                        target="_blank"
                      >
                        {{ document.generatedlink }}
                      </a>
                    </p>
                  </span>
                </b-collapse>
              </div>
              <div class="d-block accordion mb-1">
                <div class="border bg-dark-50 p-2" v-b-toggle.log-3>
                  <div class="row">
                    <div class="col-3 d-flex align-items-center">
                      <i
                        class="fa fa-whatsapp"
                        v-b-tooltip.hover
                        title="Whatsapp"
                      ></i>
                      <span class="font-weight-bold font-14 ml-2">
                        Lusifer Boswell
                      </span>
                    </div>
                    <div class="col-6 d-flex">
                      <span>Request for Passport</span>
                    </div>
                    <div
                      class="col-3 d-flex align-items-center justify-content-end"
                    >
                      <span class="font-12 mr-2">2022-08-19 06:37:47</span>
                      <i class="fa fa-chevron-up open"></i>
                      <i class="fa fa-chevron-down closed"></i>
                    </div>
                  </div>
                </div>
                <b-collapse id="log-3" class="p-2 border border-top-0">
                  <strong>Message:</strong>
                  <span class="ml-3">
                    <p>Hello mark,</p>
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry.
                    </p>
                    <p>
                      Here is the link to upload your documents:
                      <a
                        class="text-bold"
                        :href="document.generatedlink"
                        target="_blank"
                      >
                        {{ document.generatedlink }}
                      </a>
                    </p>
                  </span>
                </b-collapse>
              </div>
              <div class="d-block accordion">
                <div class="border bg-dark-50 p-2" v-b-toggle.log-4>
                  <div class="row">
                    <div class="col-3 d-flex align-items-center">
                      <i class="fa fa-inbox" v-b-tooltip.hover title="SMS"></i>
                      <span class="font-weight-bold font-14 ml-2">
                        Robert Evans
                      </span>
                    </div>
                    <div class="col-6 d-flex">
                      <span>Request for Passport</span>
                    </div>
                    <div
                      class="col-3 d-flex align-items-center justify-content-end"
                    >
                      <span class="font-12 mr-2">2022-08-19 06:37:47</span>
                      <i class="fa fa-chevron-up open"></i>
                      <i class="fa fa-chevron-down closed"></i>
                    </div>
                  </div>
                </div>
                <b-collapse id="log-4" class="p-2 border border-top-0">
                  <strong>Message:</strong>
                  <span class="ml-3">
                    <p>Hello mark,</p>
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry.
                    </p>
                    <p>
                      Here is the link to upload your documents:
                      <a
                        class="text-bold"
                        :href="document.generatedlink"
                        target="_blank"
                      >
                        {{ document.generatedlink }}
                      </a>
                    </p>
                  </span>
                </b-collapse>
              </div>
            </div>
          </b-collapse>
        </div>
        <div class="card" id="customer_uploaded_documents">
          <div
            class="header border-bottom accordian-toggle"
            v-b-toggle.customerUploadedDocuments
          >
            <h5 class="text-primary font-weight-normal mb-0">
              Customer Uploaded Documents
            </h5>
          </div>
          <b-collapse
            id="customerUploadedDocuments"
            @show="getCustomerUploadedDocuments"
          >
            <div class="body">
              <!-- Filters Section -->
              <div class="row mb-3">
                <div class="col-md-2">
                  <b-form-group label="Status" label-size="sm" class="mb-0">
                    <b-form-select
                      v-model="customerDocsFilters.status"
                      :options="customerDocsStatusOptions"
                      size="sm"
                    ></b-form-select>
                  </b-form-group>
                </div>
                <div class="col-md-2">
                  <b-form-group
                    label="Document Type"
                    label-size="sm"
                    class="mb-0"
                  >
                    <b-form-select
                      v-model="customerDocsFilters.document_type"
                      :options="customerDocsTypeOptions"
                      size="sm"
                    ></b-form-select>
                  </b-form-group>
                </div>
                <div class="col-md-2">
                  <b-form-group label="Date From" label-size="sm" class="mb-0">
                    <b-form-input
                      v-model="customerDocsFilters.upload_date_from"
                      type="date"
                      size="sm"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-2">
                  <b-form-group label="Date To" label-size="sm" class="mb-0">
                    <b-form-input
                      v-model="customerDocsFilters.upload_date_to"
                      type="date"
                      size="sm"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-4 d-flex align-items-end">
                  <b-button
                    variant="primary"
                    size="sm"
                    class="mr-2"
                    @click="applyCustomerDocsFilters"
                  >
                    <i class="fa fa-search"></i>
                    Filter
                  </b-button>
                  <b-button
                    variant="outline-secondary"
                    size="sm"
                    @click="resetCustomerDocsFilters"
                  >
                    <i class="fa fa-refresh"></i>
                    Reset
                  </b-button>
                </div>
              </div>

              <div
                v-if="customerUploadedDocumentsLoading"
                class="text-center py-3"
              >
                <b-spinner small></b-spinner>
                <span class="ml-2">Loading documents...</span>
              </div>
              <div v-else>
                <b-table
                  responsive
                  table-class="mb-0 table-custom border"
                  head-variant="light"
                  :items="customerUploadedDocuments"
                  :fields="customerDocsFields"
                  show-empty
                  empty-text="No documents uploaded yet"
                >
                  <template #head(created_at)="{ label }">
                    <span
                      class="cursor-pointer"
                      @click="toggleCustomerDocsSort"
                      style="cursor: pointer"
                    >
                      {{ label }}
                      <i
                        :class="
                          customerDocsSortOrder === 'DESC'
                            ? 'fa fa-sort-down'
                            : 'fa fa-sort-up'
                        "
                        class="ml-1"
                      ></i>
                    </span>
                  </template>
                  <template #cell(document_preview)="data">
                    <div
                      v-if="data.item.document_url"
                      class="document-preview text-center"
                    >
                      <!-- Image Preview -->
                      <a
                        v-if="isImageFile(data.item.document_url)"
                        :href="data.item.document_url"
                        target="_blank"
                        class="d-inline-block"
                      >
                        <img
                          :src="data.item.document_url"
                          alt="Document preview"
                          class="img-thumbnail"
                          style="
                            max-width: 80px;
                            max-height: 80px;
                            object-fit: cover;
                          "
                        />
                      </a>
                      <!-- PDF Icon -->
                      <a
                        v-else-if="isPdfFile(data.item.document_url)"
                        :href="data.item.document_url"
                        target="_blank"
                        class="document-icon text-danger d-inline-block"
                        title="Download PDF"
                      >
                        <i class="fa fa-file-pdf-o fa-3x"></i>
                      </a>
                      <!-- Word Icon -->
                      <a
                        v-else-if="isWordFile(data.item.document_url)"
                        :href="data.item.document_url"
                        target="_blank"
                        class="document-icon text-primary d-inline-block"
                        title="Download Word Document"
                      >
                        <i class="fa fa-file-word-o fa-3x"></i>
                      </a>
                      <!-- Excel Icon -->
                      <a
                        v-else-if="isExcelFile(data.item.document_url)"
                        :href="data.item.document_url"
                        target="_blank"
                        class="document-icon text-success d-inline-block"
                        title="Download Excel File"
                      >
                        <i class="fa fa-file-excel-o fa-3x"></i>
                      </a>
                      <!-- Generic File Icon -->
                      <a
                        v-else
                        :href="data.item.document_url"
                        target="_blank"
                        class="document-icon text-secondary d-inline-block"
                        title="Download File"
                      >
                        <i class="fa fa-file-o fa-3x"></i>
                      </a>
                    </div>
                    <span v-else class="text-muted text-center d-block">-</span>
                  </template>
                  <template #cell(document_type)="data">
                    <span class="text-capitalize">
                      {{ data.value ? data.value.replace(/_/g, " ") : "-" }}
                    </span>
                  </template>
                  <template #cell(status)="data">
                    <p class="function-badge badge-group-table mb-0">
                      <span
                        class="badge ml-0 d-block"
                        :class="{
                          'badge-warning': data.value === 'pending',
                          'badge-success': data.value === 'approved',
                          'badge-danger': data.value === 'rejected',
                          'badge-info': data.value === 'resubmission_requested',
                        }"
                      >
                        {{
                          data.value
                            ? data.value.replace(/_/g, " ").toUpperCase()
                            : "-"
                        }}
                      </span>
                    </p>
                  </template>
                  <template #cell(created_at)="data">
                    {{ formatDateOrDash(data.value) }}
                  </template>
                  <template #cell(user_notes)="data">
                    <span
                      v-if="data.value"
                      v-b-tooltip.hover
                      :title="data.value"
                      class="d-inline-block text-truncate"
                      style="max-width: 120px"
                    >
                      {{ data.value }}
                    </span>
                    <span v-else>-</span>
                  </template>
                  <template #cell(admin_comment)="data">
                    <span
                      v-if="data.value"
                      v-b-tooltip.hover
                      :title="data.value"
                      class="d-inline-block text-truncate"
                      style="max-width: 150px"
                    >
                      {{ data.value }}
                    </span>
                    <span v-else>-</span>
                  </template>
                  <template #cell(updated_by_name)="data">
                    {{ data.value || "-" }}
                  </template>
                  <template #cell(action)="data">
                    <b-dropdown
                      text="Actions"
                      right
                      variant="outline-primary"
                      size="sm"
                    >
                      <b-dropdown-item
                        v-if="
                          data.item.status === 'pending' &&
                          data.item.document_type !== 'remitcare_claim'
                        "
                        @click="approveDocument(data.item)"
                      >
                        <i class="fa fa-check text-success mr-2"></i>
                        Approve
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="
                          data.item.status === 'pending' &&
                          data.item.document_type !== 'remitcare_claim'
                        "
                        @click="openRejectModal(data.item)"
                      >
                        <i class="fa fa-times text-danger mr-2"></i>
                        Reject
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="
                          (data.item.status === 'pending' ||
                            data.item.status === 'rejected') &&
                          data.item.document_type !== 'remitcare_claim'
                        "
                        @click="openResubmissionModal(data.item)"
                      >
                        <i class="fa fa-refresh text-info mr-2"></i>
                        Request Resubmission
                      </b-dropdown-item>
                      <b-dropdown-divider
                        v-if="
                          data.item.status === 'pending' &&
                          data.item.document_url &&
                          data.item.document_type !== 'remitcare_claim'
                        "
                      ></b-dropdown-divider>
                      <b-dropdown-item
                        v-if="data.item.document_url"
                        :href="data.item.document_url"
                        target="_blank"
                      >
                        <i class="fa fa-eye text-primary mr-2"></i>
                        View Document
                      </b-dropdown-item>
                    </b-dropdown>
                  </template>
                </b-table>
                <!-- Pagination -->
                <div
                  v-if="customerDocsTotalRows > 0"
                  class="d-flex flex-wrap align-items-center justify-content-between py-2"
                >
                  <div class="per-page mr-3">
                    <b-form-group
                      label="Per page"
                      label-for="docs-per-page-select"
                      class="mb-0"
                    >
                      <b-form-select
                        id="docs-per-page-select"
                        v-model="customerDocsPerPage"
                        :options="customerDocsPageOptions"
                        size="sm"
                      ></b-form-select>
                    </b-form-group>
                  </div>
                  <div class="number-page">
                    <b-pagination
                      v-model="customerDocsCurrentPage"
                      :total-rows="customerDocsTotalRows"
                      :per-page="customerDocsPerPage"
                      first-text="First"
                      last-text="Last"
                      align="right"
                      size="sm"
                    ></b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </b-collapse>
        </div>
        <div class="card" id="remitter_notification_logs">
          <div
            class="header border-bottom accordian-toggle"
            v-b-toggle.remitterNotification
          >
            <h5 class="text-primary font-weight-normal mb-0">
              Remitter Notification Log
            </h5>
          </div>
          <b-collapse id="remitterNotification">
            <div class="body">
              <div class="d-block accordion mb-1">
                <div class="border bg-dark-50 p-2" v-b-toggle.customer-log-1>
                  <div class="row">
                    <div class="col-3 d-flex align-items-center">
                      <span class="font-weight-bold font-14">
                        Mark Richards
                      </span>
                    </div>
                    <div class="col-3 d-flex">
                      <strong class="mr-2">Notification Type:</strong>
                      <span>Push Notification</span>
                    </div>
                    <div class="col-3 d-flex">
                      <strong class="mr-2">Notification Action:</strong>
                      <span>ID Notification</span>
                    </div>
                    <div
                      class="col-3 d-flex align-items-center justify-content-end"
                    >
                      <span class="font-12 mr-2">2022-08-19 06:37:47</span>
                      <i class="fa fa-chevron-up open"></i>
                      <i class="fa fa-chevron-down closed"></i>
                    </div>
                  </div>
                </div>
                <b-collapse id="customer-log-1" class="p-2 border border-top-0">
                  <strong>Message:</strong>
                  <span class="ml-3">
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer took a galley of type and scrambled it to make a
                      type specimen book. It has survived not only five
                      centuries, but also the leap into electronic typesetting,
                      remaining essentially unchanged.
                    </p>
                  </span>
                </b-collapse>
              </div>
              <div class="d-block accordion mb-1">
                <div class="border bg-dark-50 p-2" v-b-toggle.customer-log-2>
                  <div class="row">
                    <div class="col-3 d-flex align-items-center">
                      <span class="font-weight-bold font-14">
                        Selena Parker
                      </span>
                    </div>
                    <div class="col-3 d-flex">
                      <strong class="mr-2">Notification Type:</strong>
                      <span>Dismiss popup</span>
                    </div>
                    <div class="col-3 d-flex">
                      <strong class="mr-2">Notification Action:</strong>
                      <span>Other</span>
                    </div>
                    <div
                      class="col-3 d-flex align-items-center justify-content-end"
                    >
                      <span class="font-12 mr-2">2022-08-19 06:37:47</span>
                      <i class="fa fa-chevron-up open"></i>
                      <i class="fa fa-chevron-down closed"></i>
                    </div>
                  </div>
                </div>
                <b-collapse id="customer-log-2" class="p-2 border border-top-0">
                  <strong>Message:</strong>
                  <span class="ml-3">
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer took a galley of type and scrambled it to make a
                      type specimen book. It has survived not only five
                      centuries, but also the leap into electronic typesetting,
                      remaining essentially unchanged.
                    </p>
                  </span>
                </b-collapse>
              </div>
              <div class="d-block accordion mb-1">
                <div class="border bg-dark-50 p-2" v-b-toggle.customer-log-3>
                  <div class="row">
                    <div class="col-3 d-flex align-items-center">
                      <span class="font-weight-bold font-14">
                        Lusifer Boswell
                      </span>
                    </div>
                    <div class="col-3 d-flex">
                      <strong class="mr-2">Notification Type:</strong>
                      <span>Dismiss popup</span>
                    </div>
                    <div class="col-3 d-flex">
                      <strong class="mr-2">Notification Action:</strong>
                      <span>ID Notification</span>
                    </div>
                    <div
                      class="col-3 d-flex align-items-center justify-content-end"
                    >
                      <span class="font-12 mr-2">2022-08-19 06:37:47</span>
                      <i class="fa fa-chevron-up open"></i>
                      <i class="fa fa-chevron-down closed"></i>
                    </div>
                  </div>
                </div>
                <b-collapse id="customer-log-3" class="p-2 border border-top-0">
                  <strong>Message:</strong>
                  <span class="ml-3">
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer took a galley of type and scrambled it to make a
                      type specimen book. It has survived not only five
                      centuries, but also the leap into electronic typesetting,
                      remaining essentially unchanged.
                    </p>
                  </span>
                </b-collapse>
              </div>
              <div class="d-block accordion mb-1">
                <div class="border bg-dark-50 p-2" v-b-toggle.customer-log-4>
                  <div class="row">
                    <div class="col-3 d-flex align-items-center">
                      <span class="font-weight-bold font-14">
                        Benjamin Walker
                      </span>
                    </div>
                    <div class="col-3 d-flex">
                      <strong class="mr-2">Notification Type:</strong>
                      <span>Push Notification</span>
                    </div>
                    <div class="col-3 d-flex">
                      <strong class="mr-2">Notification Action:</strong>
                      <span>E-Wallet Notification</span>
                    </div>
                    <div
                      class="col-3 d-flex align-items-center justify-content-end"
                    >
                      <span class="font-12 mr-2">2022-08-19 06:37:47</span>
                      <i class="fa fa-chevron-up open"></i>
                      <i class="fa fa-chevron-down closed"></i>
                    </div>
                  </div>
                </div>
                <b-collapse id="customer-log-4" class="p-2 border border-top-0">
                  <strong>Message:</strong>
                  <span class="ml-3">
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer took a galley of type and scrambled it to make a
                      type specimen book. It has survived not only five
                      centuries, but also the leap into electronic typesetting,
                      remaining essentially unchanged.
                    </p>
                  </span>
                </b-collapse>
              </div>
              <div class="d-block accordion mb-1">
                <div class="border bg-dark-50 p-2" v-b-toggle.customer-log-5>
                  <div class="row">
                    <div class="col-3 d-flex align-items-center">
                      <span class="font-weight-bold font-14">
                        Ragnar Lothbrok
                      </span>
                    </div>
                    <div class="col-3 d-flex">
                      <strong class="mr-2">Notification Type:</strong>
                      <span>Email</span>
                    </div>
                    <div class="col-3 d-flex">
                      <strong class="mr-2">Notification Action:</strong>
                      <span>E-Wallet Notification</span>
                    </div>
                    <div
                      class="col-3 d-flex align-items-center justify-content-end"
                    >
                      <span class="font-12 mr-2">2022-08-19 06:37:47</span>
                      <i class="fa fa-chevron-up open"></i>
                      <i class="fa fa-chevron-down closed"></i>
                    </div>
                  </div>
                </div>
                <b-collapse id="customer-log-5" class="p-2 border border-top-0">
                  <strong>Message:</strong>
                  <span class="ml-3">
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer took a galley of type and scrambled it to make a
                      type specimen book. It has survived not only five
                      centuries, but also the leap into electronic typesetting,
                      remaining essentially unchanged.
                    </p>
                  </span>
                </b-collapse>
              </div>
            </div>
          </b-collapse>
        </div>

        <div class="card">
          <div
            class="header border-bottom accordian-toggle"
            v-b-toggle.remitterCredits
            @click="getRemitterCredits"
          >
            <h5 class="text-primary font-weight-normal mb-0">
              Remitter Credits
            </h5>
          </div>
          <b-collapse id="remitterCredits">
            <div class="body">
              <div
                class="chart-top-action d-flex flex-wrap align-items-end py-3"
              >
                <div class="mr-2" style="min-width: 220px">
                  <div class="form-group form-select m-0 single-multiselect">
                    <span class="float-label w-100">
                      <label for="transaction">Credit Type</label>
                      <multiselect
                        placeholder=""
                        v-model="remitterCreditFilter.creditType"
                        :show-labels="false"
                        :options="creditTypeOptions"
                        label="text"
                        track-by="value"
                        :searchable="true"
                      ></multiselect>
                    </span>
                  </div>
                </div>

                <!-- Date From -->
                <div class="mr-2" style="min-width: 180px">
                  <div class="form-group datepicker m-0">
                    <b-input-group class="flex-nowrap">
                      <div class="input-group-prepend">
                        <span class="input-group-text">From</span>
                        <span
                          class="input-group-text"
                          @click="$refs.fromDate.showCalendar()"
                        >
                          <i class="icon-calendar"></i>
                        </span>
                      </div>
                      <datepicker
                        class="form-control"
                        ref="fromDate"
                        v-model="remitterCreditFilter.date_from"
                        :bootstrap-styling="false"
                        placeholder=""
                        :typeable="true"
                      ></datepicker>
                    </b-input-group>
                  </div>
                </div>

                <!-- Date To -->
                <div class="mr-2" style="min-width: 180px">
                  <div class="form-group datepicker m-0">
                    <b-input-group class="flex-nowrap">
                      <div class="input-group-prepend">
                        <span class="input-group-text">To</span>
                        <span
                          class="input-group-text"
                          @click="$refs.toDate.showCalendar()"
                        >
                          <i class="icon-calendar"></i>
                        </span>
                      </div>
                      <datepicker
                        class="form-control"
                        ref="toDate"
                        v-model="remitterCreditFilter.date_to"
                        :bootstrap-styling="false"
                        placeholder=""
                        :typeable="true"
                      ></datepicker>
                    </b-input-group>
                  </div>
                </div>

                <div class="mr-2 mt-2 mt-lg-0">
                  <b-button variant="primary" @click="searchRemitterCredits">
                    Search
                  </b-button>
                </div>

                <!-- Cancel Button -->
                <div class="mt-2 mt-lg-0">
                  <b-button
                    variant="outline-secondary"
                    @click="clearRemitterCreditFilters"
                  >
                    Cancel
                  </b-button>
                </div>
                <!-- Add Credit Button -->
                <div class="d-flex flex-column align-items-end ml-auto">
                  <!-- Add Credit Button -->
                  <b-button
                    variant="success"
                    class="mb-2"
                    @click="openAddCreditModal"
                  >
                    Add Credit
                  </b-button>

                  <!-- Pagination -->
                  <div class="number-page">
                    <b-pagination
                      class="pagination-small"
                      v-model="currentPage"
                      :total-rows="totalRows"
                      first-text="First"
                      last-text="Last"
                      :per-page="perPage"
                      align="right"
                    ></b-pagination>
                  </div>
                </div>
              </div>
              <b-table
                ref="credittable"
                responsive
                hover
                table-class="js-basic-example table-custom mb-0 border"
                head-variant="light"
                :items="
                  typeof remitterCredit === 'array' ||
                  typeof remitterCredit === 'object'
                    ? remitterCredit
                    : []
                "
                :fields="remitterCreditfields"
                :per-page="perPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                striped
                show-empty
              >
                <template #cell(action)="data">
                  <button
                    class="btn btn-sm btn-primary mr-2"
                    @click="editRemitterCredit(data.item)"
                    title="Edit"
                  >
                    <i class="fa fa-edit"></i>
                  </button>
                  <button
                    class="btn btn-sm btn-danger"
                    @click="deleteRemitterCredit(data.item)"
                    title="Delete"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </template>
              </b-table>
              <!-- Table Pagination -->
              <div
                class="py-3 align-items-center justify-content-between table-pagination"
                :class="totalRows > 0 ? ' d-flex' : 'd-none'"
              >
                <div class="per-page">
                  <b-form-group
                    label="Per page"
                    label-for="per-page-select"
                    class="mb-0"
                  >
                    <b-form-select
                      id="per-page-select"
                      v-model="perPage"
                      :options="pageOptions"
                      size="sm"
                    ></b-form-select>
                  </b-form-group>
                </div>
                <div class="number-page">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    first-text="First"
                    last-text="Last"
                    :per-page="perPage"
                    align="right"
                  ></b-pagination>
                </div>
                <div class="go-page">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Go to Page</span>
                    </div>
                    <input
                      type="text"
                      v-model="currentPageJump"
                      class="form-control"
                      value=""
                      @keyup.enter="onEnter"
                      onkeypress="
                        return event.charCode >= 48 && event.charCode <= 57;
                      "
                    />
                  </div>
                </div>
              </div>

              <!-- Add Credit Modal -->
              <b-modal
                id="addCreditModal"
                v-model="showAddCreditModal"
                :title="modaltitle"
                size="md"
                hide-footer
                no-close-on-backdrop
                no-stacking
                hide-header-close
                @hidden="resetForm"
              >
                <ValidationObserver v-slot="{ passes }">
                  <form
                    @submit.prevent="passes(submitAddCredit)"
                    autocomplete="off"
                  >
                    <ValidationProvider
                      name="Wallet"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div class="form-group">
                        <label for="Wallet">
                          Wallet
                          <span class="text-danger">*</span>
                        </label>
                        <b-form-select
                          id="Wallet"
                          v-model="addCreditForm.wallet"
                          :options="walletOptions"
                          label="name"
                          track-by="id"
                          placeholder="Select Wallet"
                          :show-labels="false"
                          class="form-control"
                          :class="{ 'is-invalid': errors[0] }"
                        >
                          <template #first>
                            <b-form-select-option :value="null" disabled>
                              -- Select Option --
                            </b-form-select-option>
                          </template>
                        </b-form-select>
                        <span class="text-danger error-msg">
                          {{ errors[0] }}
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="creditType"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div class="form-group">
                        <label for="creditType">
                          Credit Type
                          <span class="text-danger">*</span>
                        </label>
                        <b-form-select
                          id="creditType"
                          v-model="addCreditForm.creditType"
                          :options="creditTypeOptions"
                          class="form-control"
                          :class="{ 'is-invalid': errors[0] }"
                        >
                          <template #first>
                            <b-form-select-option :value="null" disabled>
                              -- Select Option --
                            </b-form-select-option>
                          </template>
                        </b-form-select>
                        <span class="text-danger error-msg">
                          {{ errors[0] }}
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="amount"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div class="form-group">
                        <label for="lastname">
                          Amount
                          <span class="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="amount"
                          v-model="addCreditForm.amount"
                          class="form-control"
                          :class="{ 'is-invalid': errors[0] }"
                          placeholder="Enter amount"
                        />
                        <span class="text-danger error-msg">
                          {{ errors[0] }}
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="reason"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors:
                            (errors.length && !addCreditForm.reason) ||
                            errors[0],
                          success: addCreditForm.reason && !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <textarea
                            class="form-control"
                            id="reason"
                            v-model="addCreditForm.reason"
                            placeholder=" "
                          ></textarea>
                          <label for="reason" class="control-label">
                            Reason
                            <span class="text-danger">*</span>
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="
                              (errors.length && !addCreditForm.reason) ||
                              errors[0]
                            "
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="addCreditForm.reason && !errors[0]"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <div class="d-flex justify-content-end mt-4">
                      <b-button
                        variant="outline-secondary"
                        size="lg"
                        class="mr-3"
                        @click="hideModal"
                        :disabled="isSubmitting"
                      >
                        Cancel
                      </b-button>
                      <b-button
                        type="submit"
                        variant="primary"
                        size="lg"
                        v-if="!editMode"
                        :disabled="isSubmitting"
                      >
                        <span v-if="isSubmitting">
                          <b-spinner small></b-spinner>
                          Creating...
                        </span>
                        <span v-else>Add Credit</span>
                      </b-button>
                      <b-button
                        type="submit"
                        variant="primary"
                        size="lg"
                        v-if="editMode"
                        :disabled="isSubmitting"
                      >
                        <span v-if="isSubmitting">
                          <b-spinner small></b-spinner>
                          Updating...
                        </span>
                        <span v-else>Update Credit</span>
                      </b-button>
                    </div>
                  </form>
                </ValidationObserver>
              </b-modal>
            </div>
          </b-collapse>
        </div>

        <div class="card">
          <div
            class="header border-bottom accordian-toggle"
            v-b-toggle.activitylogs
          >
            <h5 class="text-primary font-weight-normal mb-0">
              Remitter Activity Logs
            </h5>
          </div>
          <b-collapse id="activitylogs">
            <div class="body"></div>
          </b-collapse>
        </div>
      </div>
    </div>
    <main-loader :loading="isLoading"></main-loader>

    <!-- Document Reject Modal -->
    <b-modal
      id="documentRejectModal"
      title="Reject Document"
      size="md"
      @hidden="resetDocumentActionModal"
      :no-close-on-backdrop="documentActionLoading"
      :no-close-on-esc="documentActionLoading"
      :hide-header-close="documentActionLoading"
    >
      <div class="form-group">
        <label for="rejectReason">
          Reason for Rejection
          <span class="text-danger">*</span>
        </label>
        <b-form-textarea
          id="rejectReason"
          v-model="documentRejectReason"
          placeholder="Please provide the reason for rejecting this document..."
          rows="4"
          required
          :disabled="documentActionLoading"
        ></b-form-textarea>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="secondary"
          @click="cancel()"
          :disabled="documentActionLoading"
        >
          Cancel
        </b-button>
        <b-button
          variant="danger"
          @click="submitRejectDocument"
          :disabled="documentActionLoading"
        >
          <b-spinner
            small
            v-if="documentActionLoading"
            class="mr-1"
          ></b-spinner>
          {{ documentActionLoading ? "Rejecting..." : "Reject" }}
        </b-button>
      </template>
    </b-modal>

    <!-- Document Resubmission Request Modal -->
    <b-modal
      id="documentResubmissionModal"
      title="Request Document Resubmission"
      size="md"
      @hidden="resetDocumentActionModal"
      :no-close-on-backdrop="documentActionLoading"
      :no-close-on-esc="documentActionLoading"
      :hide-header-close="documentActionLoading"
    >
      <div class="form-group">
        <label for="resubmissionReason">
          Reason for Resubmission
          <span class="text-danger">*</span>
        </label>
        <b-form-textarea
          id="resubmissionReason"
          v-model="documentResubmissionReason"
          placeholder="Please explain why the customer needs to resubmit this document..."
          rows="4"
          required
          :disabled="documentActionLoading"
        ></b-form-textarea>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="secondary"
          @click="cancel()"
          :disabled="documentActionLoading"
        >
          Cancel
        </b-button>
        <b-button
          @click="submitResubmissionRequest"
          :disabled="documentActionLoading"
          style="background-color: #4ac9b0; border-color: #4ac9b0; color: white"
        >
          <b-spinner
            small
            v-if="documentActionLoading"
            class="mr-1"
          ></b-spinner>
          {{ documentActionLoading ? "Submitting..." : "Request Resubmission" }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
const moment = require("moment");
const { ValidationObserver, ValidationProvider } = require("vee-validate");
import { mapState, mapGetters } from "vuex";
const { VueEditor } = require("vue2-editor");
import "@/plugins/vee-validate";
const LoaderComponent =
  require("@/components/admin/loader/LoaderComponent.vue").default;
import { ISLOADING } from "../../../../store/mutations.type";
import {
  GET_CUSTOMER_ADDRESS,
  UPDATE_CUSTOMER_ADDRESS,
  GET_CUSTOMER_DETAILS,
  GET_CUSTOMER_IDSCAN,
  GET_CUSTOMER_IDIMAGES,
  GET_BANKACCOUNTS,
  GET_MOMOACCOUNTS,
  GET_CUSTOMER_COMMENTS,
  POST_CUSTOMER_COMMENT,
  UPDATE_CUSTOMER_COMMENT,
  GET_CUSTOMER_ACTIVITY_LOGS,
  GET_CUSTOMER_UPLOADED_DOCUMENTS,
  UPDATE_CUSTOMER_DOCUMENT_STATUS,
  GET_REMITTER_CREDIT,
  GET_REMITTER_WALLET_LIST,
  GET_WALLET_CREDIT_TYPE_LIST,
  POST_CUSTOMER_CREDIT,
  UPDATE_CUSTOMER_CREDIT,
  DELETE_CUSTOMER_CREDIT,
} from "../../../../store/actions.type.js";
import { myFunction } from "@/common/common-helper.js";
export default {
  name: "ChannelsComponent",
  components: {
    ValidationObserver,
    ValidationProvider,
    VueEditor,
    Multiselect: () => import("vue-multiselect"),
    Datepicker: () => import("vuejs-datepicker"),
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
    "main-loader": LoaderComponent,
    IdAndAccount: () => import("./IdAndAccount.vue"),
    PersonalInfo: () => import("./PersonalInfo.vue"),
    Risk: () => import("./Risk.vue"),
    Address: () => import("./Address.vue"),
    IdReverification: () => import("./IdReverification.vue"),
  },
  props: {
    // When used in modal, pass the customer ID directly (not encrypted)
    customerId: {
      type: String,
      default: null,
    },
    // When true, hides breadcrumbs and adjusts layout for modal context
    isModal: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    modaltitle: "",
    editMode: false,
    isSubmitting: false,
    apiError: null,
    selectCreditId: "",
    totalRows: 1,
    currentPage: 1,
    currentPageJump: 1,
    perPage: 10,
    pageOptions: [10, 100, 150, { value: 1000, text: 1000 }],
    sortBy: "regdate",
    sortDesc: true,
    sortDirection: "asc",
    remitterCreditFilter: {
      credit_type: null,
      date_from: "",
      date_to: "",
    },
    remitterCredit: [],
    remitterCreditfields: [
      {
        key: "credit_type",
        label: "Credit Type",
        sortable: true,
        thClass: "th_sortfix",
      },
      {
        key: "wallet",
        label: "Wallet",
        sortable: true,
        thClass: "th_sortfix",
      },
      {
        key: "totalamountsent",
        label: "Total Amount Sent",
        sortable: true,
        thClass: "th_sortfix",
      },
      { key: "date", label: "Date", sortable: true, thClass: "th_sortfix" },
      {
        key: "createdby",
        label: "Created by",
        sortable: true,
        thClass: "th_sortfix",
      },
      {
        key: "action",
        label: "Action",
        thClass: "th_sortfix text-center",
        tdClass: "text-center",
      },
    ],
    // Add Credit Modal State
    showAddCreditModal: false,
    addCreditForm: {
      wallet: null,
      creditType: null,
      amount: "",
      reason: "",
    },
    walletOptions: [],
    creditTypeOptions: [],
    customerUploadedDocuments: [],
    customerUploadedDocumentsLoading: false,
    customerDocsTotalRows: 0,
    customerDocsCurrentPage: 1,
    customerDocsPerPage: 10,
    customerDocsPageOptions: [10, 25, 50, 100],
    customerDocsFilters: {
      status: null,
      document_type: null,
      upload_date_from: null,
      upload_date_to: null,
    },
    customerDocsStatusOptions: [
      { value: null, text: "All Statuses" },
      { value: "pending", text: "Pending" },
      { value: "approved", text: "Approved" },
      { value: "rejected", text: "Rejected" },
      { value: "resubmission_requested", text: "Resubmission Requested" },
    ],
    customerDocsTypeOptions: [
      { value: null, text: "All Types" },
      { value: "income_verification", text: "Income Verification" },
      { value: "remitcare_claim", text: "Remitcare Claim" },
    ],
    customerDocsSortBy: "created_at",
    customerDocsSortOrder: "DESC",
    customerDocsFields: [
      {
        key: "document_preview",
        label: "Document",
        tdClass: "align-middle text-center",
        thClass: "text-center",
        thStyle: { width: "80px" },
      },
      {
        key: "document_type",
        label: "Document Type",
        tdClass: "align-middle",
        thStyle: { width: "120px" },
      },
      {
        key: "status",
        label: "Status",
        tdClass: "align-middle text-center",
        thClass: "text-center",
        thStyle: { width: "140px" },
      },
      {
        key: "created_at",
        label: "Uploaded Date",
        tdClass: "align-middle text-center",
        thClass: "text-center",
        thStyle: { width: "150px" },
      },
      {
        key: "user_notes",
        label: "User Notes",
        tdClass: "align-middle",
        thStyle: { width: "120px" },
      },
      {
        key: "admin_comment",
        label: "Admin Comment",
        tdClass: "align-middle",
        thStyle: { width: "150px" },
      },
      {
        key: "updated_by_name",
        label: "Updated By",
        tdClass: "align-middle text-center",
        thClass: "text-center",
        thStyle: { width: "120px" },
      },
      {
        key: "action",
        label: "Action",
        tdClass: "align-middle text-center",
        thClass: "text-center",
        thStyle: { width: "80px" },
      },
    ],
    selectedDocForAction: null,
    documentRejectReason: "",
    documentResubmissionReason: "",
    documentActionLoading: false,
    IDimages: [],
    IDdocuments: [],
    slide: null,
    addComment: null,
    editComentMsg: null,
    commentId: null,
    document: {
      type: "",
      other: "",
      generatedlink: "",
    },
    documentEmail: {
      documenttype: "",
      other: "",
      type: "Email",
      push_notification: {
        title: "Test",
        content:
          "Hello [customer_name],\n\nHere is the link to upload your documents: [document_upload_link]",
      },
      email_notification_subject: "Request for [document_name]",
      email_notification_content:
        "<p>Hello [customer_name],</p><p><br></p><p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p><p><br></p><p>Here is the link to upload your documents: [document_upload_link]</p>",
      sms_notification_content:
        "Hello [customer_name],\n\nHere is the link to upload your documents: [document_upload_link]",
      whatsapp_notification_content:
        "Hello [customer_name],\n\nLorem Ipsum is simply dummy text of the printing and typesetting industry.\n\nHere is the link to upload your documents: [document_upload_link]",
    },
    cardList: [
      {
        name: "MasterCard",
        type: "Credit",
        card_number: ".... .... 1548",
      },
    ],
    banksaccounts: [],
    momoaccounts: [],
    bankAccountsloaded: false,
    momoAccountsloaded: false,
    cardListloaded: false,
    cardListfields: [
      { key: "type", label: "Type", thClass: "th_sortfix" },
      { key: "card_number", label: "Card Number", thClass: "th_sortfix" },
      {
        key: "block_status",
        label: "Block Status",
        thClass: "th_sortfix text-right pr-4",
        tdClass: "text-right",
      },
    ],
    bankfields: [
      { key: "name", label: "Name", thClass: "th_sortfix" },
      { key: "account_number", label: "Account Number", thClass: "th_sortfix" },
      {
        key: "block_status",
        label: "Block Status",
        thClass: "th_sortfix text-right pr-4",
        tdClass: "text-right",
      },
    ],
    momoaccountfields: [
      { key: "network", label: "Network", thClass: "th_sortfix" },
      { key: "momo_number", label: "Mobile Number", thClass: "th_sortfix" },
      {
        key: "block_status",
        label: "Block Status",
        thClass: "th_sortfix text-right pr-4",
        tdClass: "text-right",
      },
    ],
    usercomments: [],
    activityLogs: [],
    activityLogsLoading: false,
    breadCrumbIteams: [],
    isAllChecked: false,
    documentType_options: [
      "Passport",
      "Driving License",
      "National ID",
      "Foreigner ID (must be of Country of Residence)",
      "National ID (must be of Country of Residence)",
      "Proof of Address",
      "Source of funds (e.g Bank statement/Pay Slips)",
      "Selfie verification ",
      "Other",
    ],
    notificationTypeOptions: [
      "Push notification",
      "Dismiss popup",
      "Model popup",
    ],
    notificationActionOptions: ["ID Notification", "Other"],
    notification: {
      type: "",
      action: "",
      custom: "",
    },
    addressDetail: {
      id: "",
      addressline1: "",
      addressline2: "",
      addressline3: "",
      state: "",
      city: "",
      postalcode: "",
      sourceCountry: "",
      loaded: false,
    },
    oldAddresses: [],
    basicInfo: {},
    blockStatuses: [
      { value: "Monitor" },
      { value: "Restricted" },
      { value: "Suspended" },
      { value: "Terminated" },
      { value: "Blacklisted" },
      { value: "Approved" },
    ],
    accountStatuses: [
      { value: "Active" },
      { value: "Inactive" },
      { value: "Locked Out" },
      { value: "Disabled" },
    ],
    idScanDetails: [],
    idImageDetails: [],
    countrys_options: [],
  }),
  methods: {
    // view edit Accounts page
    viewAccounts(data) {
      let params = {};
      if (data.account_number) {
        params.name = "Bank Account";
        params.value = data.account_number;
      }
      if (data.momo_number) {
        params.name = "MOMO Account";
        params.value = data.momo_number;
      }
      this.$router.push({
        path: "/accounts/edit",
        query: {
          name: this.$CryptoJS.AES.encrypt(params.name, "name").toString(),
          value: this.$CryptoJS.AES.encrypt(params.value, "value").toString(),
        },
      });
    },
    // Get remitter bank accounts details
    getBankAccounts() {
      if (this.bankAccountsloaded) {
        return;
      }
      const id = this.decryptedCustomerId;
      const tempitems = [];
      let tempparam = `?customerId=${id}`;
      this.$store.dispatch(GET_BANKACCOUNTS, tempparam).then((response) => {
        if (response.status == 200) {
          let details = response.data.details;
          details.map((item) => {
            let accounts = {
              name: item.bank_name ? item.bank_name : "-",
              branchname: item.branchname ? item.branchname : "-",
              account_number: item.account_number ? item.account_number : "-",
            };
            tempitems.push(accounts);
          });
        } else {
          this.$toast.error(response.data.message, { position: "top-right" });
        }
        this.bankAccountsloaded = true;
        this.banksaccounts = tempitems;
      });
    },
    // Get remitter momo accounts details
    getmomoAccounts() {
      if (this.momoAccountsloaded) {
        return;
      }
      const id = this.decryptedCustomerId;
      const tempitems = [];
      let tempparam = `?customerId=${id}`;
      this.$store.dispatch(GET_MOMOACCOUNTS, tempparam).then((response) => {
        if (response.status == 200) {
          let details = response.data.details;
          details.map((item) => {
            let accounts = {
              network: item.provider_name,
              momo_number: item.wallet_number,
            };
            tempitems.push(accounts);
          });
        } else {
          this.$toast.error(response.data.message, { position: "top-right" });
        }
        this.momoAccountsloaded = true;
        this.momoaccounts = tempitems;
      });
    },
    // Get customer uploaded documents
    getCustomerUploadedDocuments() {
      const id = this.decryptedCustomerId;
      this.customerUploadedDocumentsLoading = true;

      // Build query params with pagination, sorting, and filters
      // Add timestamp to prevent browser caching
      let queryParams = `?page=${this.customerDocsCurrentPage}&limit=${this.customerDocsPerPage}&_t=${Date.now()}`;
      queryParams += `&sort_by=${this.customerDocsSortBy}&sort_order=${this.customerDocsSortOrder}`;

      // Add filters if set
      if (this.customerDocsFilters.status) {
        queryParams += `&status=${this.customerDocsFilters.status}`;
      }
      if (this.customerDocsFilters.document_type) {
        queryParams += `&document_type=${this.customerDocsFilters.document_type}`;
      }
      if (this.customerDocsFilters.upload_date_from) {
        queryParams += `&upload_date_from=${this.customerDocsFilters.upload_date_from}`;
      }
      if (this.customerDocsFilters.upload_date_to) {
        queryParams += `&upload_date_to=${this.customerDocsFilters.upload_date_to}`;
      }

      this.$store
        .dispatch(GET_CUSTOMER_UPLOADED_DOCUMENTS, {
          customerId: id,
          queryParams,
        })
        .then((response) => {
          if (response.status === 200) {
            this.customerUploadedDocuments = response.data.documents || [];
            if (response.data.pagination) {
              this.customerDocsTotalRows = response.data.pagination.total || 0;
            }
          } else {
            this.$toast.error(
              response.data?.message || "Failed to fetch documents",
              {
                position: "top-right",
              },
            );
          }
          this.customerUploadedDocumentsLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.$toast.error("Failed to fetch customer documents", {
            position: "top-right",
          });
          this.customerUploadedDocumentsLoading = false;
        });
    },
    // Apply filters for customer documents
    applyCustomerDocsFilters() {
      this.customerDocsCurrentPage = 1;
      this.getCustomerUploadedDocuments();
    },
    // Reset filters for customer documents
    resetCustomerDocsFilters() {
      this.customerDocsFilters = {
        status: null,
        document_type: null,
        upload_date_from: null,
        upload_date_to: null,
      };
      this.customerDocsCurrentPage = 1;
      this.getCustomerUploadedDocuments();
    },
    // Toggle sort order for customer documents
    toggleCustomerDocsSort() {
      this.customerDocsSortOrder =
        this.customerDocsSortOrder === "DESC" ? "ASC" : "DESC";
      this.getCustomerUploadedDocuments();
    },
    // File type detection helpers
    getFileExtension(url) {
      if (!url) return "";
      const cleanUrl = url.split("?")[0];
      const parts = cleanUrl.split(".");
      return parts.length > 1 ? parts.pop().toLowerCase() : "";
    },
    isImageFile(url) {
      const ext = this.getFileExtension(url);
      return ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg"].includes(ext);
    },
    isPdfFile(url) {
      return this.getFileExtension(url) === "pdf";
    },
    isWordFile(url) {
      const ext = this.getFileExtension(url);
      return ["doc", "docx"].includes(ext);
    },
    isExcelFile(url) {
      const ext = this.getFileExtension(url);
      return ["xls", "xlsx", "csv"].includes(ext);
    },
    // Date formatting helper
    formatDateOrDash(value) {
      if (!value) return "-";
      const moment = require("moment-timezone");
      const formatted = moment(value).format("YYYY-MM-DD h:mm:ss A");
      return formatted === "Invalid date" ? "-" : formatted;
    },
    // Document action methods
    approveDocument(doc) {
      this.$swal
        .fire({
          title: "Confirm Approval",
          text: "Are you sure you want to approve this document?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Yes, Approve",
          cancelButtonText: "Cancel",
          confirmButtonColor: "#4AC9B0",
        })
        .then((result) => {
          if (result.isConfirmed) {
            // Show the main loader
            this.$store.commit(ISLOADING, true);
            this.updateDocumentStatusWithCallback(
              doc.id,
              "approved",
              null,
              () => {
                this.$store.commit(ISLOADING, false);
              },
            );
          }
        });
    },
    openRejectModal(doc) {
      this.selectedDocForAction = doc;
      this.documentRejectReason = "";
      this.$bvModal.show("documentRejectModal");
    },
    openResubmissionModal(doc) {
      this.selectedDocForAction = doc;
      this.documentResubmissionReason = "";
      this.$bvModal.show("documentResubmissionModal");
    },
    submitRejectDocument() {
      if (!this.documentRejectReason.trim()) {
        this.$toast.error("Please provide a reason for rejection", {
          position: "top-right",
        });
        return;
      }
      this.updateDocumentStatus(
        this.selectedDocForAction.id,
        "rejected",
        this.documentRejectReason,
      );
    },
    submitResubmissionRequest() {
      if (!this.documentResubmissionReason.trim()) {
        this.$toast.error("Please provide a reason for resubmission request", {
          position: "top-right",
        });
        return;
      }
      this.updateDocumentStatus(
        this.selectedDocForAction.id,
        "resubmission_requested",
        this.documentResubmissionReason,
      );
    },
    resetDocumentActionModal() {
      this.selectedDocForAction = null;
      this.documentRejectReason = "";
      this.documentResubmissionReason = "";
      this.documentActionLoading = false;
    },
    updateDocumentStatus(documentId, status, reason = null) {
      // Map status to API action values
      const statusToActionMap = {
        approved: "approve",
        rejected: "reject",
        resubmission_requested: "request_resubmission",
      };
      const action = statusToActionMap[status] || status;

      const payload = {
        documentId,
        action,
        admin_comment: reason,
      };

      // Set loading state for modal spinners
      this.documentActionLoading = true;

      this.$store
        .dispatch(UPDATE_CUSTOMER_DOCUMENT_STATUS, payload)
        .then((response) => {
          // Check for any successful response (2xx status codes)
          const isSuccess =
            response && response.status >= 200 && response.status < 300;

          if (isSuccess) {
            // Refresh the documents list FIRST to ensure it always happens
            this.getCustomerUploadedDocuments();

            // Then handle UI updates
            this.$bvModal.hide("documentRejectModal");
            this.$bvModal.hide("documentResubmissionModal");
            this.resetDocumentActionModal();
            this.$toast.success(
              `Document ${status.replace(/_/g, " ")} successfully`,
              {
                position: "top-right",
              },
            );
          } else {
            this.documentActionLoading = false;
            this.$toast.error(
              response?.data?.message || "Failed to update document status",
              {
                position: "top-right",
              },
            );
          }
        })
        .catch((error) => {
          console.log(error);
          this.documentActionLoading = false;
          this.$toast.error("Failed to update document status", {
            position: "top-right",
          });
        });
    },
    updateDocumentStatusWithCallback(
      documentId,
      status,
      reason = null,
      onComplete = null,
    ) {
      // Map status to API action values
      const statusToActionMap = {
        approved: "approve",
        rejected: "reject",
        resubmission_requested: "request_resubmission",
      };
      const action = statusToActionMap[status] || status;

      const payload = {
        documentId,
        action,
        admin_comment: reason,
      };

      this.$store
        .dispatch(UPDATE_CUSTOMER_DOCUMENT_STATUS, payload)
        .then((response) => {
          const isSuccess =
            response && response.status >= 200 && response.status < 300;

          // Call the callback first to close any loading indicators
          if (onComplete) onComplete();

          if (isSuccess) {
            this.getCustomerUploadedDocuments();
            this.$toast.success(
              `Document ${status.replace(/_/g, " ")} successfully`,
              {
                position: "top-right",
              },
            );
          } else {
            this.$toast.error(
              response?.data?.message || "Failed to update document status",
              {
                position: "top-right",
              },
            );
          }
        })
        .catch((error) => {
          console.log(error);
          if (onComplete) onComplete();
          this.$toast.error("Failed to update document status", {
            position: "top-right",
          });
        });
    },
    changeEmailSubject() {
      this.documentEmail.email_notification_subject = `Request for ${
        this.documentEmail.documenttype.split("(")[0]
      }`;
    },
    handleEditorInput() {
      if (this.sms_notification_content.length > 320) {
        // Truncate the content to the maximum allowed characters
        this.sms_notification_content = this.sms_notification_content.slice(
          0,
          320,
        );
      }
    },

    handleKeyDown(event) {
      if (
        this.sms_notification_content.length >= 320 &&
        event.key !== "Backspace"
      ) {
        // Prevent typing beyond the character limit
        event.preventDefault();
      }
    },
    sendDocumentemailSubmit() {
      console.log(this.documentEmail);
      this.$bvModal.hide("sendDocumentNotification");
    },
    cancelmodel() {
      this.$bvModal.hide("generateDocumentUpload");
      this.document.type = null;
      this.document.generatedlink = null;
    },
    copyLink() {
      // console.log(this.$route.params?.customer_id);
      let url = `${window.location.origin}/document-upload/link/${
        this.$route.path.split("/customer/edit/")[1]
      }`;
      var m = document;
      url = m.createTextNode(url);
      var w = window;
      var b = m.body;
      var d = {};
      b.appendChild(url);
      if (b.createTextRange) {
        d = b.createTextRange();
        d.moveToElementText(url);
        d.select();
        m.execCommand("copy");
      } else {
        d = m.createRange();
        var g = w.getSelection;
        d.selectNodeContents(url);
        g().removeAllRanges();
        g().addRange(d);
        m.execCommand("copy");
        g().removeAllRanges();
      }
      url.remove();
      myFunction.showInfo("Linked Copied", "success");
    },
    generateUploadLink() {
      console.log(this.document.type);
      // this.$bvModal.hide('generateDocumentUpload');
      // this.document.type = null;
      this.document.generatedlink = `${window.location.origin}/document-upload/link/${
        this.$route.path.split("/customer/edit/")[1]
      }`;
    },
    createComment() {
      const id = this.decryptedCustomerId;
      let params = {
        remitter_id: id,
        comment: this.addComment,
        created_by: localStorage.getItem("userid"),
      };
      this.$store.dispatch(POST_CUSTOMER_COMMENT, params).then((response) => {
        if (response.status == 200) {
          this.addComment = null;
          myFunction.showInfo(response.data.message, "success");
        } else {
          myFunction.showInfo(response.data.message, "error");
        }
        this.getComments();
      });
    },
    scrollToLatest() {
      const parentElement = this.$refs.comments;
      parentElement.scrollTop = parentElement.scrollHeight + 100;
      parentElement.lastChildElement?.scrollIntoView({
        behavior: "smooth",
      });
    },
    // Get customer basic details
    getCustomerDetails() {
      const id = this.decryptedCustomerId;

      this.$store.dispatch(GET_CUSTOMER_DETAILS, id).then((response) => {
        if (response.status == 200) {
          this.basicInfo = response.data.details;
        } else {
          console.error("Error fetching customer details:", response);
        }
      });
    },
    // Get address details
    getaddressDetails() {
      if (this.addressDetail.loaded) {
        return;
      }
      const id = this.decryptedCustomerId;
      this.$store.commit(ISLOADING, true);
      this.$store.dispatch(GET_CUSTOMER_ADDRESS, id).then((response) => {
        if (response.status == 200) {
          const address = response.data.details.filter(
            (item) => item.isActive === true,
          )[0];
          this.oldAddresses = response.data.details.filter(
            (item) => item.isActive === false,
          );
          if (address) {
            this.addressDetail = {
              id: address.addressId ? address.addressId : "",
              addressline1: address.addressline1 ? address.addressline1 : "",
              addressline2: address.addressline2 ? address.addressline2 : "",
              addressline3: address.addressline3 ? address.addressline3 : "",
              state: address.state ? address.state : "",
              city: address.city ? address.city : "",
              postalcode: address.postalcode ? address.postalcode : "",
              sourceCountry: this.countryList.filter(
                (item) => item.countryid === address?.countryId,
              )[0],
            };
          }
        } else {
          // this.$toast.error(response.data.message, { position: 'top-right' });
        }
        this.addressDetail.loaded = true;
        this.$store.commit(ISLOADING, false);
      });
    },
    // Update address
    addressDataSubmit() {
      const id = this.decryptedCustomerId;
      let params = {
        customer_id: id,
        addressline1: this.addressDetail.addressline1,
        addressline2: this.addressDetail.addressline2,
        addressline3: this.addressDetail.addressline3,
        state: this.addressDetail.state,
        city: this.addressDetail.city,
        postalcode: this.addressDetail.postalcode,
        countryId: this.addressDetail.sourceCountry.countryid,
      };
      if (this.addressDetail.id != "") {
        params.addressId = this.addressDetail.id;
      }
      this.$store.dispatch(UPDATE_CUSTOMER_ADDRESS, params).then((response) => {
        if (response.status == 200 || response.status == 201) {
          myFunction.showInfo(response.data.message, "success");
          this.isDisplayPhoneError = false;
          this.getaddressDetails();
        } else {
          myFunction.showInfo(response.data.message, "error");
        }
      });
    },

    // Get customer cards list
    getcustomerCards() {
      if (this.cardListloaded) {
        return;
      }
      // const id = this.$CryptoJS.AES.decrypt(this.$route.params?.customer_id,'customer_id').toString(this.$CryptoJS.enc.Utf8);
      // const tempitems = [];
      // this.$store.dispatch(CUSTOMER_CARD_LIST,id).then((response) => {
      //     if(response.status == 200){
      //         response.data.data.map((item) => {
      //             let cards = {
      //                 name:item.bin_details.scheme,
      //                 type:item.bin_details.type,
      //                 card_number:'.... .... .... '+item.last4digits
      //             };
      //             tempitems.push(cards);
      //         });
      //         this.cardList = tempitems;
      //         this.cardListloaded = true;
      //     } else {
      //         console.log(response);
      //     }
      //     this.cardListloaded = true;
      // })
    },
    // get ID Documents Uploaded in IDScan
    getcustomerIdscan() {
      const id = this.decryptedCustomerId;
      this.$store.dispatch(GET_CUSTOMER_IDSCAN, id).then((response) => {
        if (response.status == 200) {
          let idscan = response.data.details;
          this.idScanDetails = idscan;
          idscan.map((data) => {
            // require(`@/assets/passport.png`),
            // require(`@/assets/license.png`),
            if (data.selfieVerificationURL) {
              this.IDimages.push(data.selfieVerificationURL);
            }
            if (data.documentUrl) {
              this.IDdocuments.push(data.documentUrl);
            }
          });
        }
      });
    },
    // get ID Documents Images from new API endpoint
    getcustomerIdImages() {
      const id = this.decryptedCustomerId;
      this.$store.dispatch(GET_CUSTOMER_IDIMAGES, id).then((response) => {
        if (response.status == 200) {
          let idImages = response.data.details;
          this.idImageDetails = idImages;
          this.IDimages = []; // Clear existing images
          this.IDdocuments = []; // Clear existing documents

          idImages.map((data) => {
            if (data.selfieImgURL) {
              this.IDimages.push(data.selfieImgURL);
              this.IDdocuments.push({
                url: data.selfieImgURL,
                name: "Selfie Image",
              });
            }
            if (data.idImgURL) {
              this.IDimages.push(data.idImgURL);
              this.IDdocuments.push({
                url: data.idImgURL,
                name: "ID Document",
              });
            }
          });
        }
      });
    },

    // Get remitter comment details
    getComments() {
      this.$store.commit(ISLOADING, true);
      const id = this.decryptedCustomerId;
      const tempitems = [];
      this.$store.dispatch(GET_CUSTOMER_COMMENTS, id).then((response) => {
        if (response.status == 200) {
          response.data.details.map((item) => {
            let comments = {
              id: item.id,
              name: item.createdbyusername
                ? item.createdbyusername
                : item.remitter_name,
              date: moment(item.created_at).format("YYYY-MM-DD HH:mm:ss"),
              comment: item.comment,
              edited: item.updatedbyusername ? true : false,
              editedby: item.updatedbyusername ? item.updatedbyusername : "",
              editOn: item.updated_at
                ? moment(item.updated_at).format("YYYY-MM-DD HH:mm:ss")
                : "",
            };
            tempitems.push(comments);
          });
          this.usercomments = tempitems;
        } else {
          console.log(response);
        }
      });
    },

    // Get activity logs for customer
    getActivityLogs() {
      const id = this.decryptedCustomerId;

      this.activityLogsLoading = true;
      this.$store
        .dispatch(GET_CUSTOMER_ACTIVITY_LOGS, id)
        .then((response) => {
          if (response.status == 200 && response.data.details) {
            this.activityLogs = response.data.details.map((log) => {
              return {
                ...log,
                requestExpanded: false,
                responseExpanded: false,
                deviceInfoExpanded: false,
                outcomeExpanded: false,
                actionExpanded: false,
              };
            });
          } else {
            console.log("Error fetching activity logs:", response);
            this.activityLogs = [];
          }
        })
        .catch((error) => {
          console.error("Failed to fetch activity logs:", error);
          this.activityLogs = [];
        })
        .finally(() => {
          this.activityLogsLoading = false;
        });
    },

    // Helper method to get action text based on HTTP method
    getActionText(method) {
      const methodMap = {
        POST: "Created",
        PUT: "Updated",
        PATCH: "Updated",
        DELETE: "Deleted",
        GET: "Viewed",
      };
      return methodMap[method?.toUpperCase()] || method;
    },

    editComment(data) {
      this.commentId = data.id;
      this.editComentMsg = data.comment;
      this.$bvModal.show("editComment");
    },

    // update comment
    updateComment() {
      const id = this.decryptedCustomerId;
      let params = {
        commentid: this.commentId,
        customerid: id,
        comment: this.editComentMsg,
        updated_by: localStorage.getItem("userid"),
      };

      this.$store.dispatch(UPDATE_CUSTOMER_COMMENT, params).then((response) => {
        if (response.status == 200) {
          myFunction.showInfo(response.data.message, "success");
        } else {
          myFunction.showInfo(response.data.message, "error");
        }
        this.$bvModal.hide("editComment");
        this.editComentMsg = null;
        this.getComments();
      });
    },

    // Search credit
    searchRemitterCredits() {
      this.$store.commit(ISLOADING, true);
      this.getRemitterCredits();
    },

    clearRemitterCreditFilters() {
      this.remitterCreditFilter.creditType = null;
      this.remitterCreditFilter.date_from = "";
      this.remitterCreditFilter.date_to = "";
      this.currentPage = 1;
      this.getRemitterCredits();
    },

    onEnter(e) {
      var paginationMenu = Math.ceil(this.totalRows / this.perPage);
      if (e.target.value > 0) {
        if (paginationMenu >= e.target.value) {
          this.currentPage = this.currentPageJump = e.target.value;
        } else {
          this.currentPage = this.currentPageJump = paginationMenu;
        }
      } else {
        this.currentPage = this.currentPageJump = 1;
      }
    },

    // Get remitter credit
    getRemitterCredits() {
      this.getCustomerwiseWallet();
      this.creditTypeList();

      const id = this.decryptedCustomerId;

      let page = "";
      let page_size = "";
      let sortby = "";
      let sort = false;
      if (this.currentPage != undefined) {
        page = this.currentPage;
      } else {
        page = 1;
      }
      if (this.perPage != undefined) {
        page_size = this.perPage;
      } else {
        page_size = 10;
      }
      if (this.sortBy == "") {
        sortby = "createdAt";
      } else if (this.sortBy == "name") {
        sortby = "firstname";
      } else {
        sortby = this.sortBy;
      }
      if (this.sortDesc == true) {
        sort = "DESC";
      } else {
        sort = "ASC";
      }
      let tempparam = `sort=${sort}&sortby=${sortby}&limit=${page_size}&page=${page}&customerid=${id}`;

      if (this.remitterCreditFilter.creditType) {
        tempparam =
          tempparam +
          `&credit_type=${this.remitterCreditFilter.creditType.value}`;
      }

      if (
        this.remitterCreditFilter.date_from &&
        this.remitterCreditFilter.date_to
      ) {
        tempparam =
          tempparam +
          `&date_from=${this.remitterCreditFilter.date_from}&date_to=${this.remitterCreditFilter.date_to}`;
      }

      this.$store.commit(ISLOADING, true);
      const tempitems = [];
      this.$store.dispatch(GET_REMITTER_CREDIT, tempparam).then((response) => {
        if (response.status == 200) {
          response.data.details.map((item) => {
            let comments = {
              id: item.id,
              credit_type_id: item.credit_type_id,
              credit_type: item.credit_type_name,
              walletid: item.walletid,
              wallet: item.walletName,
              createdby: item.userfname + " " + item.userlname,
              totalamountsent: parseFloat(item.amount).toFixed(2),
              date: moment(item.created_at).format("YYYY-MM-DD HH:mm:ss"),
              comment: item.reason,
            };
            tempitems.push(comments);
          });
          this.totalRows = response.data.query.total;
          this.remitterCredit = tempitems;
        } else {
          console.log(response);
        }
        this.remitterCredit.loaded = true;
        this.$store.commit(ISLOADING, false);
      });
    },

    getCustomerwiseWallet() {
      const id = this.decryptedCustomerId;
      this.$store.commit(ISLOADING, true);
      const tempitems = [];
      this.$store.dispatch(GET_REMITTER_WALLET_LIST, id).then((response) => {
        if (response.status == 200) {
          const wallets = response.data.details || [];
          wallets.map((item) => {
            let comments = {
              value: item.id,
              text: item.name,
            };
            tempitems.push(comments);
          });
          this.walletOptions = tempitems;
          // Populate basicInfo.wallets for the PayAngel Wallet card
          this.basicInfo = {
            ...this.basicInfo,
            wallets: wallets.map((item) => ({
              name: item.name,
              walletnumber: item.walletnumber || item.id,
              availablebalance:
                item.availablebalance ?? item.available_balance ?? 0,
              actualbalance: item.actualbalance ?? item.actual_balance ?? 0,
              currencycode: item.currencycode || item.currency_code || "GBP",
            })),
          };
        } else {
          console.log(response);
        }
        this.$store.commit(ISLOADING, false);
      });
    },

    creditTypeList() {
      this.$store.commit(ISLOADING, true);
      const tempitems = [];
      this.$store.dispatch(GET_WALLET_CREDIT_TYPE_LIST).then((response) => {
        if (response.status == 200) {
          response.data.details.map((item) => {
            let comments = {
              value: item.id,
              text: item.name,
            };
            tempitems.push(comments);
          });
          this.creditTypeOptions = tempitems;
        } else {
          console.log(response);
        }
        this.$store.commit(ISLOADING, false);
      });
    },

    openAddCreditModal() {
      this.modaltitle = "Add Credit";
      this.resetForm();
      this.showAddCreditModal = true;
    },

    hideModal() {
      this.selectCreditId = "";
      this.editMode = false;
      this.showAddCreditModal = false;
    },

    resetForm() {
      this.isSubmitting = false;
      this.addCreditForm = {
        wallet: null,
        creditType: null,
        amount: "",
        reason: "",
      };
    },

    // Add Credit Modal Submission
    submitAddCredit() {
      if (this.editMode) {
        this.updateRemitterCredit();
      } else {
        this.addRemitterCredit();
      }
    },

    async addRemitterCredit() {
      this.isSubmitting = true;
      try {
        const id = this.decryptedCustomerId;
        const payload = {
          customerid: id,
          walletid: this.addCreditForm.wallet,
          credit_type_id: this.addCreditForm.creditType,
          amount: parseFloat(parseFloat(this.addCreditForm.amount).toFixed(2)),
          reason: this.addCreditForm.reason,
          created_by: localStorage.getItem("userid"),
        };
        const response = await this.$store.dispatch(
          POST_CUSTOMER_CREDIT,
          payload,
        );

        if (response.data && response.data.code === "1003-000") {
          myFunction.showInfo("Credit added successfully.", "success");
          this.resetForm();
          this.showAddCreditModal = false;
          this.$store.commit(ISLOADING, true);
          this.getRemitterCredits();
        } else {
          const errorMessage =
            response.data?.message ||
            "Failed to create user role. Please try again.";
          const errorDetail = response.data?.detail;
          this.apiError = errorDetail
            ? `${errorMessage}: ${errorDetail}`
            : errorMessage;
          myFunction.showInfo(this.apiError, "error");
        }
      } catch (error) {
        this.isSubmitting = false;
        console.error("Error adding bin:", error);
        const errorMessage =
          error.response?.data?.message ||
          "An error occurred while creating the remitter credit. Please try again.";
        const errorDetail = error.response?.data?.detail;
        this.apiError = errorDetail
          ? `${errorMessage}: ${errorDetail}`
          : errorMessage;
        myFunction.showInfo(this.apiError, "error");
      }
    },

    async updateRemitterCredit() {
      this.isSubmitting = true;
      const params = {
        creditid: this.selectCreditId,
        walletid: this.addCreditForm.wallet,
        credit_type_id: this.addCreditForm.creditType,
        amount: parseFloat(parseFloat(this.addCreditForm.amount).toFixed(2)),
        reason: this.addCreditForm.reason,
      };
      this.$store
        .dispatch(UPDATE_CUSTOMER_CREDIT, params)
        .then((response) => {
          if (response.status == 200) {
            myFunction.showInfo(response.data.message, "success");
            this.resetForm();
            this.showAddCreditModal = false;
            this.$store.commit(ISLOADING, true);
            this.getRemitterCredits();
          } else {
            this.isSubmitting = false;
            myFunction.showInfo(response.data.message, "error");
          }
        })
        .catch((error) => {
          console.error("Error updating remitter credit:", error);
          this.isSubmitting = false;
          myFunction.showInfo(
            "An error occurred while updating the remitter credit. Please try again.",
            "error",
          );
        });
    },

    // Edit Remitter Credit
    editRemitterCredit(data) {
      this.modaltitle = "Edit Credit";
      this.editMode = true;
      this.selectCreditId = data.id;
      this.addCreditForm.wallet = data.walletid;
      this.addCreditForm.creditType = data.credit_type_id;
      this.addCreditForm.amount = data.totalamountsent;
      this.addCreditForm.reason = data.comment;
      this.showAddCreditModal = true;
    },

    // Delete Remitter Credit
    deleteRemitterCredit(data) {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary btn-lg my-3",
          cancelButton: "btn btn-outline-secondary btn-lg",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You want to delete this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            let params = data.id;
            this.$store
              .dispatch(DELETE_CUSTOMER_CREDIT, params)
              .then((response) => {
                if (response.status == 200) {
                  myFunction.showInfo(response.data.message, "success");
                  this.$store.commit(ISLOADING, true);
                  this.getRemitterCredits();
                } else {
                  myFunction.showInfo(response.data.message, "error");
                }
              })
              .catch((error) => {
                console.error("Error deleting remitter credit:", error);
                myFunction.showInfo(
                  "An error occurred while deleting the remitter credit. Please try again.",
                  "error",
                );
              });
          }
        });
    },
  },
  computed: {
    ...mapGetters(["isLoading", "countryList", "sourcecountryList"]),
    ...mapState({
      apiErrors: (state) => state.auth.errors,
    }),
    decryptedCustomerId() {
      // If customerId prop is provided (modal mode), use it directly
      if (this.customerId) {
        return this.customerId;
      }
      // Otherwise decrypt from route params (standalone page mode)
      return this.$CryptoJS.AES.decrypt(
        this.$route.params?.customer_id,
        "customer_id",
      ).toString(this.$CryptoJS.enc.Utf8);
    },
    selfieDocuments() {
      return this.IDdocuments.filter((doc) => doc.name === "Selfie Image");
    },
    idDocuments() {
      return this.IDdocuments.filter((doc) => doc.name === "ID Document");
    },
  },
  mounted() {
    this.scrollToLatest();
    this.getCustomerDetails();
    this.getcustomerIdscan();
    this.getcustomerIdImages();
    this.getComments();
    this.getCustomerwiseWallet(); // Load wallet data for PayAngel Wallet card
    // Only set document link in standalone page mode (not in modal)
    if (!this.isModal && this.$route.path) {
      this.document.generatedlink = `${window.location.origin}/document-upload/link/${
        this.$route.path.split("/customer/edit/")[1]
      }`;
    }
  },
  watch: {
    countryList: {
      handler(newVal) {
        console.log(
          "🌍 Component: countryList updated with",
          newVal?.length || 0,
          "countries",
        );
        if (newVal?.length > 0) {
          console.log("📋 First few countries:", newVal.slice(0, 3));
        }
      },
      immediate: true,
    },
    sourcecountryList: {
      handler(newVal) {
        console.log(
          "🌍 Component: sourcecountryList updated with",
          newVal?.length || 0,
          "countries",
        );
        if (newVal?.length > 0) {
          console.log("📋 First few source countries:", newVal.slice(0, 3));
        }
      },
      immediate: true,
    },
    currentPage: {
      handler: function () {
        this.getRemitterCredits();
      },
    },
    perPage: {
      handler: function () {
        this.getRemitterCredits();
      },
    },
    customerDocsCurrentPage: {
      handler: function () {
        this.getCustomerUploadedDocuments();
      },
    },
    customerDocsPerPage: {
      handler: function () {
        this.customerDocsCurrentPage = 1;
        this.getCustomerUploadedDocuments();
      },
    },
  },
};
</script>
